// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1.5l5 5 5-5%27 fill=%27none%27 stroke=%27%230052cc%27 stroke-width=%271.8%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27%3E%3Cpath d=%27M1 5l3.5 3.5L11 1.5%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/auckland-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  max-width: 100%;
  /* Prevent sideways scroll from wide sections. \`clip\` rather than \`hidden\`:
     hidden on both html and body turns body into a scroll container, which
     silently stops every position: sticky element on the site from sticking.
     Older browsers that don't know \`clip\` fall back to \`hidden\`. */
  overflow-x: hidden;
  overflow-x: clip;
}

img,
video {
  max-width: 100%;
  height: auto;
}

:root {
  --primary: #0052cc;
  --primary-light: #e6f0ff;
  --secondary: #00a3ff;
  --accent: #0f9d58;
  --text-main: #1b1f3b;
  --text-muted: #5f6473;
  --bg: #f5f7fb;
  --white: #ffffff;
  --shadow-soft: 0 10px 30px rgba(15, 35, 95, 0.08);
  --radius-lg: 18px;

  /* Layout — one content column for the whole site.
     --container       : standard page width (cards, grids, service pages)
     --container-narrow: long-form reading measure (About, Privacy, Disclosure)
     --gutter          : minimum breathing room at the viewport edge
     Replaces ten separate max-widths (620/720/780/800/860/900/980/1100/1120). */
  --container: 1120px;
  --container-narrow: 720px;
  --gutter: 24px;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background-color: var(--bg);
  color: var(--text-main);
}

a {
  text-decoration: none;
  color: inherit;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 1;
  padding-top: var(--nav-offset); /* clears the floating navbar */
}


/* ===========================
   LAYOUT HELPERS / SECTIONS
   =========================== */

.section {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 40px 16px;
}

.section-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
  align-items: center;
  text-align: center;
}

.section-title {
  font-size: clamp(26px, 3vw, 32px);
  margin: 0;
  font-weight: 700;
}

.section-subtitle {
  font-size: 15px;
  color: var(--text-muted);
  max-width: var(--container-narrow);
  margin: 0 auto;
}

/* Shared buttons and cards (older pages) */

.btn-primary,
.btn-outline {
  border-radius: 999px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: var(--white);
  box-shadow: var(--shadow-soft);
}

.btn-outline {
  background: transparent;
  border: 1px solid #d9e2ff;
  color: var(--primary);
}

/* Cards & grids */

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

@media (max-width: 900px) {
  .card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .card-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.card {
  background: var(--white);
  border-radius: var(--radius-lg);
  padding: 18px;
  box-shadow: var(--shadow-soft);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: var(--primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
}

.card-text {
  font-size: 13px;
  color: var(--text-muted);
}

.card-link {
  font-size: 12px;
  color: var(--primary);
  margin-top: auto;
}

/* ===========================
   LOAN CALCULATOR
   =========================== */

.calculator-wrapper {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 28px;
}

.calculator-card {
  background: var(--white);
  border-radius: var(--radius-lg);
  padding: 18px;
  box-shadow: var(--shadow-soft);
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

label {
  font-size: 13px;
  font-weight: 500;
}

input,
textarea {
  border-radius: 10px;
  border: 1px solid #d1d9ec;
  padding: 8px 10px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  font-family: inherit;
}

input:focus,
textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 1px rgba(0, 82, 204, 0.16);
}

textarea {
  min-height: 90px;
  resize: vertical;
}

.result-box {
  margin-top: 12px;
  padding: 10px;
  border-radius: 10px;
  background: var(--primary-light);
  font-size: 13px;
}

/* ===========================
   SUBNAV (About / service pages)
   =========================== */

.subnav {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.subnav a {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #d9e2ff;
  color: var(--text-muted);
}

.subnav a:hover {
  border-color: var(--primary);
  color: var(--primary);
}

/* ===========================
   FOOTER
   =========================== */

.footer {
  position: relative;
  margin-top: 0;
  padding: 64px 16px 0;
  color: rgba(226, 232, 240, 0.75);
  background:
    radial-gradient(600px 300px at 0% 0%, rgba(0, 82, 204, 0.28), transparent 70%),
    radial-gradient(500px 280px at 100% 100%, rgba(0, 163, 255, 0.14), transparent 70%),
    #070e24;
}

/* Thin gradient rule along the top edge */
.footer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary), var(--secondary), transparent);
}

.footer-inner {
  max-width: var(--container);
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) repeat(4, minmax(0, 1fr));
  gap: 40px 32px;
  padding-bottom: 40px;
}

.footer-logo {
  display: inline-flex;
  padding: 10px 14px;
  border-radius: 14px;
  background: #ffffff;
}

.footer-logo img {
  display: block;
  height: 34px;
  width: auto;
}

.footer-about {
  margin: 18px 0 22px;
  max-width: 340px;
  font-size: 14.5px;
  line-height: 1.65;
}

.footer-contact-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin: 0 0 28px;
  padding: 0;
  list-style: none;
}

.footer-contact-row li {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 14.5px;
  line-height: 1.45;
}

.footer-contact-row li > span:last-child {
  min-width: 0;
}

.footer-contact-label {
  display: block;
  margin-bottom: 2px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(226, 232, 240, 0.5);
}

.footer-contact-row address {
  font-style: normal;
  color: #ffffff;
}

.footer-contact-row a {
  color: #ffffff;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.footer-contact-row a:hover {
  color: #7dd3fc;
}

.footer-contact-icon {
  flex: 0 0 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #7dd3fc;
  background: rgba(125, 211, 252, 0.1);
  border: 1px solid rgba(125, 211, 252, 0.15);
}

.footer-social {
  display: flex;
  gap: 10px;
}

.footer-social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.footer-social-link:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(125, 211, 252, 0.4);
}

.footer-social-link:focus-visible {
  outline: 2px solid #7dd3fc;
  outline-offset: 2px;
}

.footer-social-link img {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.footer-heading {
  margin: 8px 0 18px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff;
}

.footer-list {
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14.5px;
}

.footer-list a {
  color: rgba(226, 232, 240, 0.75);
  transition: color 0.15s ease, padding-left 0.2s ease;
}

.footer-list a:hover {
  color: #ffffff;
  padding-left: 4px;
}

.footer-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 24px;
  padding: 22px 0 26px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 13px;
  color: rgba(226, 232, 240, 0.55);
}

.footer-bottom p {
  margin: 0;
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 22px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-legal a {
  color: rgba(226, 232, 240, 0.75);
}

.footer-legal a:hover {
  color: #ffffff;
}

/* Tablet: brand across the top, all four link columns in one row, and the
   address tile full width with call + email side by side under it. */
@media (max-width: 1000px) {
  .footer-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-contact-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-contact-row li:first-child {
    grid-column: 1 / -1;
  }
}

/* Phone: two link columns, contact tiles stacked */
@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-contact-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 520px) {
  .footer {
    padding-top: 48px;
  }

  .footer-grid {
    gap: 32px 20px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .footer-social-link,
  .footer-list a {
    transition: none;
  }
}

/* ===========================
   CAROUSEL (older image/text carousel)
   =========================== */

.carousel {
  position: relative;
  border-radius: var(--radius-lg);
  background: var(--white);
  box-shadow: var(--shadow-soft);
  padding: 18px;
  overflow: hidden;
}

.carousel-inner {
  position: relative;
  min-height: 220px;
}

.carousel-slide {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.1fr);
  gap: 20px;
  align-items: center;
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: translateX(20px);
  transition: opacity 0.35s ease, transform 0.35s ease;
  pointer-events: none;
}

.carousel-slide.active {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
  position: relative;
}

.carousel-img-wrapper {
  border-radius: 16px;
  overflow: hidden;
}

.carousel-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}

.carousel-content h3 {
  margin: 0 0 8px;
  font-size: 20px;
}

.carousel-content p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 999px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(15, 23, 42, 0.06);
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-arrow.left {
  left: 10px;
}

.carousel-arrow.right {
  right: 10px;
}

.carousel-arrow:hover {
  background: rgba(15, 23, 42, 0.12);
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
}

.carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  border: none;
  background: #d1d5db;
  cursor: pointer;
}

.carousel-dot.active {
  width: 18px;
  background: var(--primary);
}

@media (max-width: 800px) {
  .carousel-slide {
    grid-template-columns: minmax(0, 1fr);
  }

  .carousel-img {
    height: 180px;
  }
}

/* ===========================
   IMAGE STRIP
   =========================== */

.image-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.image-strip-item {
  background: var(--white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.image-strip-photo {
  height: 150px;
  background-size: cover;
  background-position: center;
}

.image-strip-photo-1 {
  background-image: url("https://via.placeholder.com/400x250?text=First+Home");
}

.image-strip-photo-2 {
  background-image: url("https://via.placeholder.com/400x250?text=Refinance");
}

.image-strip-photo-3 {
  background-image: url("https://via.placeholder.com/400x250?text=Investment+%26+Business");
}

.image-strip-caption {
  padding: 10px 12px;
  font-size: 13px;
  color: var(--text-main);
}

@media (max-width: 900px) {
  .image-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .image-strip {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ===========================
   BANK LOGOS – STATIC
   =========================== */

.bank-logos-section {
  padding-bottom: 50px;
}

.bank-logos-row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
}

.bank-logo-card {
  flex: 0 0 auto;
  padding: 10px 16px;
  border-radius: 999px;
  background: var(--white);
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}

.bank-logo-card img {
  max-width: 90px;
  max-height: 32px;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.9;
}

.bank-logo-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-main);
}

.bank-logos-note {
  margin-top: 12px;
  font-size: 12px;
  color: var(--text-muted);
}

/* ===========================
   BANK LOGOS – INFINITE STRIP
   =========================== */

.bank-marquee-section {
  width: 100%;
  padding: 12px 0 8px;
  background: transparent;
}

.bank-marquee-label {
  font-size: 20px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #0c2f7a;
  font-weight: 750;
  text-align: center;
  margin: 0 0 10px 0;
}

.bank-marquee {
  overflow: hidden;
}

.bank-marquee-inner {
  display: inline-flex;
  align-items: center;
  gap: 40px;
  white-space: nowrap;
  will-change: transform;
  animation: bank-scroll 40s linear infinite;
}

.bank-marquee-item {
  flex: 0 0 auto;
}

.bank-marquee-item img {
  height: 80px;
  width: auto;
  object-fit: contain;
}

@keyframes bank-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 640px) {
  .bank-marquee-label {
    margin-left: 12px;
  }
  .bank-marquee-item img {
    height: 36px;
  }
}

/* ===========================
   TRUSTED ADVISORS VIDEO
   ===========================
   Video stays as the background; a navy tint keeps it on-brand and the
   text readable. */

.trust-section {
  position: relative;
  overflow: hidden;
  color: #ffffff;
  background: #0b1531;
}

.trust-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.trust-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(100deg, rgba(8, 16, 40, 0.92) 0%, rgba(8, 16, 40, 0.72) 50%, rgba(8, 16, 40, 0.38) 100%),
    radial-gradient(600px 300px at 10% 100%, rgba(0, 82, 204, 0.35), transparent 70%);
}

.trust-inner {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
  padding: 96px 16px;
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 0.9fr);
  gap: 56px;
  align-items: center;
}

.trust-kicker {
  display: block;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.trust-title {
  margin: 0 0 20px;
  font-size: clamp(30px, 3.6vw, 46px);
  line-height: 1.12;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.trust-text {
  margin: 0 0 14px;
  max-width: 580px;
  font-size: 16.5px;
  line-height: 1.75;
  color: rgba(226, 232, 240, 0.85);
}

.trust-copy .pill-btn {
  margin-top: 16px;
}

.trust-facts {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.trust-fact {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 22px 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(12px);
}

.trust-fact-value {
  flex: 0 0 auto;
  white-space: nowrap;
  width: 132px;
  font-size: 32px;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.02em;
  background: linear-gradient(90deg, #ffffff, #7dd3fc);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.trust-fact-label {
  font-size: 14.5px;
  line-height: 1.5;
  color: rgba(226, 232, 240, 0.85);
}

@media (max-width: 900px) {
  .trust-inner {
    grid-template-columns: minmax(0, 1fr);
    gap: 32px;
    padding: 64px 16px;
  }

  .trust-text {
    font-size: 15.5px;
  }

  .trust-fact-value {
    width: auto;
    min-width: 72px;
    font-size: 26px;
  }
}

/* Reduced motion: no moving background, the navy shows instead */
@media (prefers-reduced-motion: reduce) {
  .trust-video {
    display: none;
  }
}

/* ===========================
   HOME ABOUT US
   =========================== */

.about-home-section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 88px 16px;
}

.about-home-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
  gap: 56px;
  align-items: center;
}

.about-home-kicker {
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--secondary);
}

.about-home-title {
  margin: 0 0 16px;
  font-size: clamp(28px, 3.2vw, 40px);
  line-height: 1.15;
  font-weight: 800;
  color: var(--text-main);
}

.about-home-lead {
  margin: 0 0 28px;
  font-size: 17px;
  line-height: 1.7;
  color: var(--text-muted);
}

.about-home-points {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.about-home-point {
  display: flex;
  gap: 18px;
  padding: 20px 22px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.07);
  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.about-home-point:hover {
  border-color: rgba(0, 82, 204, 0.2);
  box-shadow: 0 14px 30px rgba(15, 35, 95, 0.08);
}

.about-home-point-number {
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 800;
  color: var(--primary);
  font-variant-numeric: tabular-nums;
  padding-top: 2px;
}

.about-home-point h3 {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 700;
  color: var(--text-main);
}

.about-home-point p {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: var(--text-muted);
}

.about-home-card {
  overflow: hidden;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.06);
  box-shadow: 0 24px 50px rgba(15, 35, 95, 0.12);
}

.about-home-photo img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

.about-home-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 24px 26px 26px;
}

.about-home-stat-number {
  font-size: 20px;
  font-weight: 800;
  color: var(--text-main);
}

.about-home-stat-label {
  margin-bottom: 14px;
  font-size: 15px;
  line-height: 1.55;
  color: var(--text-muted);
}

@media (max-width: 900px) {
  .about-home-section {
    padding: 56px 16px;
  }

  .about-home-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 32px;
  }

  .about-home-lead {
    font-size: 16px;
  }

  .about-home-point {
    padding: 18px;
    gap: 14px;
  }
}

/* ===========================
   “Our Services” THREE-CARD
   =========================== */

.services-section {
  padding-top: 36px;
  padding-bottom: 40px;
}

.services-carousel {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  margin-top: 8px;
}

.services-card {
  background: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  padding: 16px 18px;
  width: 260px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: transform 0.35s ease, opacity 0.35s ease, box-shadow 0.35s ease;
}

.services-card-center {
  transform: scale(1);
  opacity: 1;
  z-index: 2;
  box-shadow: 0 18px 35px rgba(15, 23, 42, 0.18);
}

.services-card-side {
  transform: scale(0.9);
  opacity: 0.75;
  z-index: 1;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08);
}

.services-card-left {
  transform: translateX(-20px) scale(0.9);
}

.services-card-right {
  transform: translateX(20px) scale(0.9);
}

.services-card-icon {
  font-size: 24px;
  margin-bottom: 4px;
}

.services-card-category {
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--secondary);
  font-weight: 700;
}

.services-card-title {
  font-size: 16px;
  font-weight: 700;
}

.services-card-subtitle {
  font-size: 13px;
  color: var(--text-muted);
}

.services-slide-in-left {
  animation: services-slide-left 0.45s ease;
}

.services-slide-in-right {
  animation: services-slide-right 0.45s ease;
}

@keyframes services-slide-left {
  from {
    opacity: 0;
    transform: translateX(-35px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes services-slide-right {
  from {
    opacity: 0;
    transform: translateX(35px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@media (max-width: 900px) {
  .services-carousel {
    gap: 10px;
  }

  .services-card {
    width: 220px;
    padding: 14px 14px;
  }
}

@media (max-width: 640px) {
  .services-carousel {
    gap: 0;
  }

  .services-card-side {
    display: none;
  }

  .services-card-center {
    width: 100%;
  }
}

/* ===========================
   LOAN SERVICES – INFINITE LOOP
   =========================== */

.loan-services-section {
  padding: 40px 0;
  width: 100vw;
  max-width: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

.section.loan-services-section {
  max-width: none;
  margin: 0;
}

.loan-loop-card {
  display: flex;
  flex: 0 0 640px;
  background: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
}

.loan-loop-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.16);
}

.loan-card-image {
  flex: 0 0 50%;
}

.loan-card-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.loan-card-content {
  flex: 1 1;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.loan-card-tag {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--secondary);
  font-weight: 700;
}

.loan-card-title {
  font-size: 20px;
  margin: 0;
  font-weight: 700;
}

.loan-card-description {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0 0 8px;
}

.loan-card-link {
  margin-top: auto;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
}

.loan-card-link:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .loan-loop-card {
    flex: 0 0 90vw;
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .loan-loop-card {
    flex: 0 0 360px;
  }
}

/* ===========================
   PROTECTION SERVICES – LOOP
   =========================== */

.protection-services-section {
  padding: 40px 0;
  width: 100vw;
  max-width: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

.section.protection-services-section {
  max-width: none;
  margin: 0;
}

.protection-loop-card {
  display: flex;
  flex: 0 0 640px;
  background: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
}

.protection-loop-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.16);
}

.protection-card-image {
  flex: 0 0 50%;
}

.protection-card-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.protection-card-content {
  flex: 1 1;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.protection-card-tag {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--secondary);
  font-weight: 700;
}

.protection-card-title {
  font-size: 20px;
  margin: 0;
  font-weight: 700;
}

.protection-card-description {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0 0 8px;
}

.protection-card-link {
  margin-top: auto;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
}

.protection-card-link:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .protection-loop-card {
    flex: 0 0 90vw;
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .protection-loop-card {
    flex: 0 0 360px;
  }
}

/* ===========================
   BUSINESS SERVICES – LOOP
   =========================== */

.business-services-section {
  padding: 40px 0;
  width: 100vw;
  max-width: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

.section.business-services-section {
  max-width: none;
  margin: 0;
}

.business-loop-card {
  display: flex;
  flex: 0 0 640px;
  background: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
}

.business-loop-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.16);
}

.business-card-image {
  flex: 0 0 50%;
}

.business-card-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.business-card-content {
  flex: 1 1;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.business-card-tag {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--secondary);
  font-weight: 700;
}

.business-card-title {
  font-size: 20px;
  margin: 0;
  font-weight: 700;
}

.business-card-description {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0 0 8px;
}

.business-card-link {
  margin-top: auto;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
}

.business-card-link:hover {
  text-decoration: underline;
}

/* ===========================
   WHOLE-CARD CLICK TARGET
   ===========================
   The service cards already looked clickable (cursor: pointer) but only the
   "Learn more" link actually went anywhere. Rather than putting an onClick on
   the card div, we stretch the existing link over the whole card with a
   pseudo-element. That keeps one real <a> per card, so keyboard tabbing,
   cmd/ctrl-click, middle-click and "open in new tab" all keep working, and the
   destination stays in one place in the JSX. */

.loan-loop-card,
.protection-loop-card,
.business-loop-card {
  position: relative;
}

.loan-card-link::after,
.protection-card-link::after,
.business-card-link::after {
  content: "";
  position: absolute;
  inset: 0;
}

/* The card is now the focus target, so show the focus ring around the card
   rather than around a few words of link text. */
.loan-card-link:focus-visible::after,
.protection-card-link:focus-visible::after,
.business-card-link:focus-visible::after {
  outline: 2px solid #2563eb;
  outline-offset: -2px;
  border-radius: var(--radius-lg);
}

@media (max-width: 900px) {
  .business-loop-card {
    flex: 0 0 520px;
  }
}

@media (max-width: 640px) {
  .business-loop-card {
    flex: 0 0 90vw;
    flex-direction: column;
  }
}

/* Pill button used by the Location section. */
.primary-btn {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 22px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 16px 40px rgba(37, 99, 235, 0.45);
}

.primary-btn:hover {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

/* ===========================
   SERVICE PAGES (/services/:id)
   ===========================
   Same language as the Contact page: navy hero behind the floating navbar,
   then light sections. */

.svc-page {
  width: 100%;
}

/* Hero */
.svc-hero {
  position: relative;
  margin-top: calc(-1 * var(--nav-offset));
  padding: calc(var(--nav-offset) + 56px) 16px 88px;
  color: #ffffff;
  background:
    radial-gradient(700px 360px at 10% 0%, rgba(0, 82, 204, 0.55), transparent 70%),
    radial-gradient(640px 360px at 95% 60%, rgba(0, 163, 255, 0.3), transparent 70%),
    #0f1b3d;
  overflow: hidden;
}

.svc-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse at 30% 40%, #000 15%, transparent 70%);
  pointer-events: none;
}

.svc-hero-inner {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 56px;
  align-items: center;
}

.svc-hero-empty .svc-hero-inner {
  grid-template-columns: minmax(0, 1fr);
  text-align: center;
}

.svc-hero-empty .svc-hero-actions {
  justify-content: center;
}

.svc-hero-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.svc-hero-empty .svc-hero-text {
  align-items: center;
}

.svc-hero-kicker {
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #7dd3fc;
  background: rgba(125, 211, 252, 0.12);
  border: 1px solid rgba(125, 211, 252, 0.25);
}

.svc-hero-title {
  margin: 18px 0 10px;
  font-size: clamp(34px, 4.2vw, 54px);
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: -0.015em;
  color: #ffffff;
}

.svc-hero-tagline {
  margin: 0 0 18px;
  font-size: 19px;
  font-weight: 600;
  color: #7dd3fc;
}

.svc-hero-desc {
  margin: 0;
  max-width: 560px;
  font-size: 16.5px;
  line-height: 1.7;
  color: rgba(226, 232, 240, 0.82);
}

.svc-hero-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 30px;
}

.svc-hero-media {
  position: relative;
}

/* Soft glow behind the photo so it sits in the navy rather than on it. */
.svc-hero-media::before {
  content: "";
  position: absolute;
  inset: 8% -4% -6% 6%;
  border-radius: 28px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  opacity: 0.35;
  filter: blur(40px);
}

.svc-hero-media img {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.35);
}

/* Buttons */
.pill-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 50px;
  padding: 13px 24px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 700;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.pill-btn svg {
  transition: transform 0.2s ease;
}

.pill-btn:hover {
  transform: translateY(-2px);
}

.pill-btn:hover svg {
  transform: translateX(3px);
}

.pill-btn-primary {
  color: #ffffff;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  box-shadow: 0 14px 32px rgba(0, 163, 255, 0.3);
}

.pill-btn-primary:hover {
  box-shadow: 0 18px 40px rgba(0, 163, 255, 0.4);
}

.pill-btn-ghost {
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.04);
}

.pill-btn-ghost:hover {
  background: rgba(255, 255, 255, 0.1);
}

.pill-btn-light {
  color: #0f1b3d;
  background: #ffffff;
}

.pill-btn-light:hover {
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
}

.pill-btn:focus-visible,
.svc-related-card:focus-visible,
.cta-band-phone:focus-visible {
  outline: 2px solid #7dd3fc;
  outline-offset: 3px;
}

/* Light sections */
.svc-section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 72px 16px 0;
}

.svc-section-head {
  margin-bottom: 28px;
}

.svc-section-kicker {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--secondary);
}

.svc-section-title {
  margin: 0;
  font-size: clamp(26px, 2.6vw, 34px);
  line-height: 1.2;
  font-weight: 800;
  color: var(--text-main);
}

/* What's included */
.svc-points {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.svc-point {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px 24px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.07);
  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);
  font-size: 16px;
  line-height: 1.55;
  color: var(--text-main);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.svc-point:hover {
  border-color: rgba(0, 82, 204, 0.2);
  box-shadow: 0 14px 30px rgba(15, 35, 95, 0.08);
}

.svc-point-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  height: 40px;
  border-radius: 12px;
  color: var(--primary);
  background: var(--primary-light);
}

/* Related services */
/* Compact image-beside-text cards; auto-fit stretches them across the row
   whether a category has two siblings or five. */
.svc-related {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}

.svc-related-card {
  display: flex;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.07);
  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.svc-related-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(15, 35, 95, 0.12);
}

.svc-related-image {
  display: block;
  flex: 0 0 38%;
  min-height: 150px;
  overflow: hidden;
  background: var(--primary-light);
}

.svc-related-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.svc-related-card:hover .svc-related-image img {
  transform: scale(1.04);
}

.svc-related-body {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 18px 20px;
}

.svc-related-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
}

.svc-related-tagline {
  margin: 4px 0 14px;
  font-size: 14.5px;
  line-height: 1.5;
  color: var(--text-muted);
}

.svc-related-more {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: auto;
  font-size: 14px;
  font-weight: 700;
  color: var(--primary);
}

.svc-related-more svg {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

.svc-related-card:hover .svc-related-more svg {
  transform: translateX(3px);
}

/* Closing band */
.cta-band-section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 72px 16px 80px;
}

.cta-band {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px 40px;
  padding: 40px 44px;
  border-radius: 28px;
  color: #ffffff;
  background:
    radial-gradient(500px 240px at 100% 0%, rgba(0, 163, 255, 0.35), transparent 70%),
    radial-gradient(420px 260px at 0% 100%, rgba(0, 82, 204, 0.5), transparent 70%),
    #0f1b3d;
  box-shadow: 0 24px 50px rgba(15, 27, 61, 0.22);
}

.cta-band-text h2 {
  margin: 0 0 6px;
  font-size: clamp(24px, 2.4vw, 30px);
  font-weight: 800;
  color: #ffffff;
}

.cta-band-text p {
  margin: 0;
  font-size: 16px;
  color: rgba(226, 232, 240, 0.8);
}

.cta-band-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
}

.cta-band-phone {
  font-size: 15px;
  font-weight: 600;
  color: #7dd3fc;
}

.cta-band-phone:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .svc-hero {
    padding: calc(var(--nav-offset) + 32px) 16px 56px;
  }

  .svc-hero-inner {
    grid-template-columns: minmax(0, 1fr);
    gap: 36px;
  }

  .svc-hero-tagline {
    font-size: 17px;
  }

  .svc-hero-desc {
    font-size: 15.5px;
  }

  .svc-section {
    padding-top: 52px;
  }

  .svc-points {
    grid-template-columns: minmax(0, 1fr);
  }

  .svc-point {
    padding: 18px;
    font-size: 15px;
  }

  .cta-band-section {
    padding-top: 52px;
    padding-bottom: 56px;
  }

  .cta-band {
    padding: 30px 22px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pill-btn,
  .pill-btn svg,
  .svc-related-card,
  .svc-related-image img,
  .svc-related-more svg {
    transition: none;
  }
}

/* ===========================
   NAVBAR
   Floating pill header, services mega menu, mobile sheet.
   Everything nav-related lives in this one block.
   =========================== */

:root {
  /* How far page content sits below the floating bar. */
  --nav-offset: 88px;
}

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 14px max(var(--gutter), calc((100% - var(--container)) / 2));
  transition: padding 0.25s ease;
}

.site-header.is-scrolled {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Without this, page content shows in the strip above the floating pill as it
   scrolls past. A masked blur fades it out and stays colour-neutral, so it
   works over the dark hero and over light sections alike. */
.site-header::before {
  content: "";
  position: absolute;
  inset: 0 0 -16px;
  pointer-events: none;
  opacity: 0;
  backdrop-filter: blur(10px);
  mask-image: linear-gradient(to bottom, #000 58%, transparent);
  transition: opacity 0.25s ease;
}

.site-header.is-scrolled::before {
  opacity: 1;
}

/* The bar itself - a pill that floats clear of the viewport edge. */
.navbar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  height: 60px;
  padding: 0 10px 0 20px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1);
  transition: height 0.25s ease, background 0.25s ease, box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.site-header.is-scrolled .navbar {
  height: 54px;
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(15, 23, 42, 0.07);
  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.16);
}

/* An open menu needs an opaque bar, otherwise the panel shows through it. */
.site-header.is-menu-open .navbar {
  background: #ffffff;
  border-color: rgba(15, 23, 42, 0.07);
  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.16);
}

.nav-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.nav-logo img {
  height: 38px;
  display: block;
  transition: height 0.25s ease;
}

.site-header.is-scrolled .nav-logo img {
  height: 34px;
}

/* ---- Desktop links ---- */

.nav-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  display: flex;
  align-items: center;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 9px 14px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1;
  color: #334155;
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.18s ease, background 0.18s ease;
}

.nav-link:hover,
.nav-item.is-open > .nav-link {
  color: #1d4ed8;
  background: rgba(37, 99, 235, 0.08);
}

.nav-links a.nav-link.active {
  color: #1d4ed8;
  font-weight: 600;
  background: rgba(37, 99, 235, 0.1);
}

.nav-caret {
  width: 12px;
  height: 12px;
  transition: transform 0.2s ease;
}

.nav-item.is-open .nav-caret {
  transform: rotate(180deg);
}

/* ---- Right side ---- */

.nav-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 11px 20px;
  border-radius: 999px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.nav-cta svg {
  width: 14px;
  height: 14px;
  transition: transform 0.18s ease;
}

.nav-cta:hover {
  filter: brightness(1.06);
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.38);
}

.nav-cta:hover svg {
  transform: translateX(3px);
}

/* ---- Hamburger ---- */

.nav-toggle {
  position: relative;
  display: none;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: #ffffff;
  cursor: pointer;
  flex-shrink: 0;
}

.nav-toggle span {
  position: absolute;
  left: 12px;
  width: 18px;
  height: 2px;
  border-radius: 2px;
  background: #0f172a;
  transition: transform 0.25s ease, opacity 0.18s ease;
}

.nav-toggle span:nth-child(1) {
  top: 15px;
}

.nav-toggle span:nth-child(2) {
  top: 20px;
}

.nav-toggle span:nth-child(3) {
  top: 25px;
}

.nav-toggle.is-open span:nth-child(1) {
  transform: translateY(5px) rotate(45deg);
}

.nav-toggle.is-open span:nth-child(2) {
  opacity: 0;
}

.nav-toggle.is-open span:nth-child(3) {
  transform: translateY(-5px) rotate(-45deg);
}

/* ---- Services mega menu (desktop) ---- */

/* The panel lives inside the Services item so keyboard order runs
   trigger -> links, but it is positioned against the bar so it can span it. */
.nav-item.services-nav {
  position: static;
}

.mega-menu {
  position: absolute;
  top: calc(100% + 14px);
  left: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s;
}

.mega-menu.is-open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.mega-menu-inner {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) 268px;
  gap: 28px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 22px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.18);
}

.mega-column {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.mega-heading {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
  padding: 0 10px;
  margin-bottom: 8px;
}

.mega-link {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 12px;
  text-decoration: none;
  transition: background 0.16s ease;
}

.mega-link:hover {
  background: #f1f5f9;
}

.mega-link-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mega-link-label {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.mega-link-blurb {
  font-size: 12px;
  line-height: 1.4;
  color: #64748b;
  margin-top: 2px;
}

/* The one promoted action in the menu, for people who cannot place themselves
   in any of the three columns. */
.mega-feature {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 22px;
  border-radius: 18px;
  background: linear-gradient(160deg, #0f172a, #1e3a8a);
  color: #ffffff;
}

.mega-feature-eyebrow {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #93c5fd;
}

.mega-feature-copy {
  font-size: 13px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.82);
  margin: 10px 0 16px;
}

.mega-feature-cta {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 18px;
  border-radius: 999px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

.mega-feature-cta svg {
  width: 14px;
  height: 14px;
  transition: transform 0.18s ease;
}

.mega-feature-cta:hover svg {
  transform: translateX(3px);
}

.mega-feature-link {
  margin-top: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.mega-feature-link:hover {
  color: #ffffff;
}

/* ---- About menu (desktop) ----
   Same panel as Services, just narrower: two link columns plus the feature
   card. Positioned against the bar like Services, and centred on it. */
.nav-item.about-nav {
  position: static;
}

.about-mega-menu {
  left: 50%;
  right: auto;
  width: min(760px, 100%);
  transform: translate(-50%, -10px);
}

.about-mega-menu.is-open {
  transform: translate(-50%, 0);
}

.about-mega-inner {
  grid-template-columns: repeat(2, minmax(0, 1fr)) 248px;
}

/* Show which About page you are on */
.about-mega-menu .mega-link.active {
  background: #eff6ff;
}

/* ---- Mobile sheet: hidden until the mobile breakpoint ---- */

.mobile-menu {
  display: none;
}

/* ---- Focus states ---- */

.site-header a:focus-visible,
.site-header button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

/* ---- Breakpoint: tablet and below ---- */

@media (max-width: 900px) {
  :root {
    --nav-offset: 74px;
  }

  .site-header {
    padding: 10px var(--gutter);
  }

  .site-header.is-scrolled {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .navbar {
    height: 54px;
    padding: 0 8px 0 16px;
    gap: 12px;
  }

  .site-header.is-scrolled .navbar {
    height: 52px;
  }

  .nav-logo img,
  .site-header.is-scrolled .nav-logo img {
    height: 32px;
  }

  .nav-center,
  .mega-menu {
    display: none;
  }

  .nav-right {
    margin-left: auto;
  }

  .nav-toggle {
    display: block;
  }

  .nav-cta {
    padding: 9px 16px;
    font-size: 13px;
    box-shadow: none;
  }

  .nav-cta svg {
    display: none;
  }

  .mobile-menu {
    display: block;
    position: fixed;
    top: var(--nav-offset);
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-12px);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-menu.is-open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .mobile-menu-inner {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 12px var(--gutter) 32px;
  }

  .mobile-menu-list {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1 1;
  }

  .mobile-link,
  .mobile-group-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 14px 4px;
    border: none;
    border-bottom: 1px solid #eef2f7;
    background: none;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    color: #0f172a;
    text-decoration: none;
    text-align: left;
    cursor: pointer;
  }

  .mobile-link.active {
    color: #1d4ed8;
  }

  .mobile-caret {
    width: 14px;
    height: 14px;
    color: #94a3b8;
    transition: transform 0.2s ease;
  }

  .mobile-caret.is-open {
    transform: rotate(180deg);
  }

  .mobile-panel {
    padding: 6px 0 12px;
  }

  .mobile-panel-group + .mobile-panel-group {
    margin-top: 12px;
  }

  .mobile-panel-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.16em;
    color: #94a3b8;
    padding: 6px 4px;
  }

  .mobile-sub-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 4px;
    font-size: 15px;
    color: #334155;
    text-decoration: none;
  }

  .mobile-sub-link.active {
    color: #1d4ed8;
    font-weight: 600;
  }

  .mobile-menu-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding-top: 24px;
  }

  .mobile-cta {
    display: block;
    width: 100%;
    padding: 14px;
    border-radius: 999px;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    text-decoration: none;
  }

  .mobile-call {
    font-size: 14px;
    color: #64748b;
  }
}

/* The CTA and the burger crowd each other on small phones. The sheet carries
   the same action, so drop the one in the bar. */
@media (max-width: 420px) {
  .nav-cta {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .site-header,
  .site-header *,
  .mobile-menu,
  .mobile-menu * {
    transition-duration: 0.01ms !important;
  }
}

/* ===========================
   FAQ SECTION
   =========================== */

.faq-section {
  padding-top: 72px;
  padding-bottom: 72px;
}

.faq-grid {
  max-width: var(--container);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.4fr);
  gap: 40px;
  align-items: start;
}

/* Intro panel: dark, like the hero, so the section has an anchor. Sticky so it
   stays alongside the list while someone reads down the answers. */
.faq-intro {
  position: sticky;
  top: calc(var(--nav-offset) + 16px);
  display: flex;
  flex-direction: column;
  padding: 36px 32px 32px;
  border-radius: 24px;
  color: #e2e8f0;
  background:
    radial-gradient(420px 220px at 100% 0%, rgba(0, 163, 255, 0.35), transparent 70%),
    radial-gradient(360px 260px at 0% 100%, rgba(0, 82, 204, 0.45), transparent 70%),
    #0f1b3d;
  box-shadow: 0 24px 50px rgba(15, 27, 61, 0.25);
  overflow: hidden;
}

.faq-kicker {
  align-self: flex-start;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #7dd3fc;
  background: rgba(125, 211, 252, 0.12);
  border: 1px solid rgba(125, 211, 252, 0.25);
}

.faq-title {
  margin: 18px 0 12px;
  font-size: clamp(28px, 2.8vw, 36px);
  line-height: 1.15;
  font-weight: 800;
  color: #ffffff;
}

.faq-lead {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: rgba(226, 232, 240, 0.8);
}

.faq-cta {
  margin-top: 32px;
  padding: 20px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.faq-cta-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

.faq-cta-text {
  margin: 0 0 16px;
  font-size: 14px;
  color: rgba(226, 232, 240, 0.75);
}

.faq-cta-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
}

.faq-cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  box-shadow: 0 12px 28px rgba(0, 163, 255, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.faq-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(0, 163, 255, 0.4);
}

.faq-cta-phone {
  font-size: 14px;
  font-weight: 600;
  color: #7dd3fc;
}

.faq-cta-phone:hover {
  text-decoration: underline;
}

/* Question list */
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(15, 35, 95, 0.07);
  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.faq-item:hover {
  border-color: rgba(0, 82, 204, 0.2);
}

.faq-item.open {
  border-color: rgba(0, 82, 204, 0.25);
  box-shadow: 0 18px 40px rgba(15, 35, 95, 0.1);
}

.faq-item-heading {
  margin: 0;
  font: inherit;
}

.faq-question {
  width: 100%;
  padding: 20px 22px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 18px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  color: var(--text-main);
  border-radius: 18px;
}

.faq-question:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.faq-number {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: rgba(0, 82, 204, 0.45);
  font-variant-numeric: tabular-nums;
  transition: color 0.25s ease;
}

.faq-item.open .faq-number {
  color: var(--primary);
}

.faq-question-text {
  flex: 1 1;
  font-size: 17px;
  font-weight: 650;
  line-height: 1.4;
}

/* Plus that turns into a minus: two bars, the vertical one rotates flat. */
.faq-toggle {
  position: relative;
  flex: 0 0 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--primary-light);
  transition: background-color 0.25s ease, transform 0.3s ease;
}

.faq-toggle::before,
.faq-toggle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 2px;
  margin: -1px 0 0 -6px;
  border-radius: 2px;
  background: var(--primary);
  transition: transform 0.3s ease, background-color 0.25s ease;
}

.faq-toggle::after {
  transform: rotate(90deg);
}

.faq-question:hover .faq-toggle {
  background: #d5e5ff;
}

.faq-item.open .faq-toggle {
  background: var(--primary);
  transform: rotate(180deg);
}

.faq-item.open .faq-toggle::before,
.faq-item.open .faq-toggle::after {
  background: #ffffff;
}

.faq-item.open .faq-toggle::after {
  transform: rotate(0deg);
}

/* Grid-row trick animates to the answer's real height, so long answers are
   never cut off the way a fixed max-height would. */
.faq-answer-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
}

.faq-item.open .faq-answer-wrapper {
  grid-template-rows: 1fr;
}

.faq-answer-inner {
  overflow: hidden;
}

.faq-answer {
  margin: 0;
  padding: 0 22px 22px 61px;
  font-size: 15px;
  line-height: 1.7;
  color: var(--text-muted);
}

@media (max-width: 900px) {
  .faq-section {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .faq-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }

  .faq-intro {
    position: static;
    padding: 28px 22px 24px;
  }

  .faq-question {
    padding: 18px 16px;
    gap: 12px;
  }

  .faq-question-text {
    font-size: 15.5px;
  }

  .faq-answer {
    padding: 0 16px 18px 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .faq-answer-wrapper,
  .faq-toggle,
  .faq-toggle::before,
  .faq-toggle::after {
    transition: none;
  }
}

/* ===========================
   RESPONSIVE TWEAKS FOR LOOPS
   =========================== */

@media (max-width: 900px) {
  .loan-services-section,
  .protection-services-section,
  .business-services-section {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* Mobile layout for service carousels */

@media (max-width: 640px) {
  .loan-loop-card,
  .protection-loop-card,
  .business-loop-card {
    flex: 0 0 90vw;
    flex-direction: column;
  }

  .loan-card-image,
  .protection-card-image,
  .business-card-image {
    flex: 0 0 auto;
  }

  .loan-card-image img,
  .protection-card-image img,
  .business-card-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .loan-card-content,
  .protection-card-content,
  .business-card-content {
    padding: 14px 14px;
  }
}

/* ===========================
   SERVICE CAROUSELS (Loans / Protection / Business)
   ===========================
   The rows sit still; visitors step through them with the arrow buttons,
   keyboard arrows, or a swipe. The rows use a wider column than the rest of
   the page (they are image-heavy and read fine wide), and bleed off the right
   edge so it is obvious there is more. */

.svc-carousel {
  --edge: max(var(--gutter), calc((100% - 1760px) / 2));
  margin-top: 6px;
}

.svc-carousel-track {
  display: flex;
  gap: 24px;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: var(--edge);
  /* Room above for the hover lift and below for the card shadow, both of
     which an overflow container would otherwise clip. */
  padding: 14px var(--edge) 34px;
  scrollbar-width: none;
}

.svc-carousel-track::-webkit-scrollbar {
  display: none;
}

.svc-carousel-track:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: -2px;
  border-radius: 12px;
}

.svc-carousel .svc-carousel-track > * {
  flex: 0 0 640px;
  flex-direction: row;
  min-height: 300px;
  scroll-snap-align: start;
}

/* Every image fills its half of the card, whatever its original shape, so
   the row reads as one even strip. */
.svc-carousel .loan-card-image,
.svc-carousel .protection-card-image,
.svc-carousel .business-card-image {
  position: relative;
  flex: 0 0 46%;
  background: var(--primary-light);
}

.svc-carousel .loan-card-image img,
.svc-carousel .protection-card-image img,
.svc-carousel .business-card-image img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.svc-carousel .loan-card-content,
.svc-carousel .protection-card-content,
.svc-carousel .business-card-content {
  padding: 24px 24px 22px;
}

/* Tag stays pinned to the top and the link to the bottom; the title and
   description sit centred in the space between, rather than leaving a hole
   above the link on cards with short copy. */
.svc-carousel .loan-card-title,
.svc-carousel .protection-card-title,
.svc-carousel .business-card-title {
  margin-top: auto;
}

/* Larger type than the base card styles: these cards are wide enough to carry
   it, and it fills the card instead of floating in white space. */
.svc-carousel .loan-card-tag,
.svc-carousel .protection-card-tag,
.svc-carousel .business-card-tag {
  font-size: 13px;
}

.svc-carousel .loan-card-title,
.svc-carousel .protection-card-title,
.svc-carousel .business-card-title {
  font-size: 25px;
  line-height: 1.2;
}

.svc-carousel .loan-card-description,
.svc-carousel .protection-card-description,
.svc-carousel .business-card-description {
  font-size: 16px;
  line-height: 1.6;
}

.svc-carousel .loan-card-link,
.svc-carousel .protection-card-link,
.svc-carousel .business-card-link {
  font-size: 15px;
}

@media (max-width: 900px) {
  .svc-carousel .loan-card-title,
  .svc-carousel .protection-card-title,
  .svc-carousel .business-card-title {
    font-size: 21px;
  }

  .svc-carousel .loan-card-description,
  .svc-carousel .protection-card-description,
  .svc-carousel .business-card-description {
    font-size: 15px;
  }
}

.svc-carousel-controls {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 var(--edge);
}

/* Page dots: one per stop. The current one stretches into a pill, so where
   you are reads at a glance instead of from the length of a thin line. */
.svc-carousel-dots {
  display: flex;
  flex: 1 1;
  align-items: center;
  gap: 8px;
}

.svc-carousel-dot {
  width: 10px;
  height: 10px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(0, 82, 204, 0.18);
  cursor: pointer;
  transition: width 0.35s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.25s ease;
}

.svc-carousel-dot:hover {
  background: rgba(0, 82, 204, 0.4);
}

.svc-carousel-dot.active {
  width: 34px;
  background: linear-gradient(90deg, var(--primary), var(--secondary));
}

.svc-carousel-dot:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 3px;
}

.svc-carousel-count {
  margin-left: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.svc-carousel-count strong {
  color: var(--text-main);
}

.svc-carousel-buttons {
  display: flex;
  gap: 10px;
}

.svc-carousel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(15, 35, 95, 0.12);
  background: var(--white);
  color: var(--primary);
  box-shadow: 0 6px 16px rgba(15, 35, 95, 0.08);
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease,
    border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.svc-carousel-btn:hover:not(:disabled) {
  background: var(--primary);
  border-color: var(--primary);
  color: var(--white);
  box-shadow: 0 10px 22px rgba(0, 82, 204, 0.28);
  transform: translateY(-2px);
}

.svc-carousel-btn:active:not(:disabled) {
  transform: translateY(0);
}

.svc-carousel-btn:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 3px;
}

.svc-carousel-btn:disabled {
  color: rgba(15, 35, 95, 0.28);
  box-shadow: none;
  cursor: default;
}

@media (max-width: 900px) {
  /* The sections pick up 16px side padding here; let the row bleed past it
     to the screen edge instead of being clipped short. */
  .svc-carousel {
    --edge: 16px;
    margin-left: -16px;
    margin-right: -16px;
  }

  .svc-carousel-track {
    gap: 16px;
  }

  .svc-carousel .svc-carousel-track > * {
    flex: 0 0 min(400px, 82vw);
    flex-direction: column;
    min-height: 0;
  }

  .svc-carousel .loan-card-image,
  .svc-carousel .protection-card-image,
  .svc-carousel .business-card-image {
    flex: 0 0 200px;
  }

  .svc-carousel .loan-card-content,
  .svc-carousel .protection-card-content,
  .svc-carousel .business-card-content {
    padding: 18px;
  }

  .svc-carousel-btn {
    width: 42px;
    height: 42px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .svc-carousel-dot,
  .svc-carousel-btn {
    transition: none;
  }
}

/* =========================
   CONTACT PAGE
   =========================
   Navy header that runs up behind the floating navbar (as the home hero does),
   with the form and details cards overlapping its bottom edge. */

.contact-page {
  width: 100%;
}

/* Hero */
.contact-hero {
  position: relative;
  width: 100%;
  margin-top: calc(-1 * var(--nav-offset));
  padding: calc(var(--nav-offset) + 64px) 16px 150px;
  color: #ffffff;
  background:
    radial-gradient(700px 320px at 15% 0%, rgba(0, 82, 204, 0.55), transparent 70%),
    radial-gradient(600px 300px at 90% 30%, rgba(0, 163, 255, 0.35), transparent 70%),
    #0f1b3d;
  overflow: hidden;
}

/* Faint grid texture so the navy doesn't read as a flat block. */
.contact-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse at center, #000 20%, transparent 75%);
  pointer-events: none;
}

.contact-hero-inner {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
  text-align: center;
}

.contact-kicker {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 700;
  color: #7dd3fc;
  background: rgba(125, 211, 252, 0.12);
  border: 1px solid rgba(125, 211, 252, 0.25);
  margin-bottom: 18px;
}

.contact-title {
  margin: 0 0 14px;
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.contact-subtitle {
  margin: 0 auto;
  max-width: 620px;
  font-size: 17px;
  text-wrap: balance;
  line-height: 1.6;
  color: rgba(226, 232, 240, 0.8);
}

/* Layout */
.contact-wrap {
  position: relative;
  width: 100%;
  margin-top: -100px;
  padding: 0 16px 80px;
}

.contact-grid {
  max-width: var(--container);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
  gap: 24px;
  align-items: stretch;
}

/* Cards */
.contact-card {
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);
  border: 1px solid rgba(15, 35, 95, 0.06);
}

.contact-card-form {
  padding: 36px 36px 32px;
}

.contact-card-header {
  margin-bottom: 26px;
}

.contact-card-header h2 {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
}

.contact-card-header p {
  margin: 0;
  font-size: 15px;
  color: var(--text-muted);
}

/* Alerts */
.contact-alert {
  margin: 0 0 20px;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
}
.contact-alert.success {
  background: rgba(34, 197, 94, 0.08);
  border-color: rgba(34, 197, 94, 0.25);
  color: #166534;
}
.contact-alert.error {
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.25);
  color: #991b1b;
}

/* Form */
.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.contact-field label,
.contact-field legend {
  display: block;
  padding: 0;
  font-size: 13.5px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #0f172a;
}

.contact-field input:not([type="radio"]),
.contact-field select,
.contact-field textarea {
  width: 100%;
  min-height: 50px;
  border-radius: 14px;
  border: 1.5px solid #e2e8f0;
  padding: 12px 16px;
  font-size: 15px;
  color: var(--text-main);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
  font-family: inherit;
  background: #f8fafc;
}

.contact-field input::placeholder,
.contact-field textarea::placeholder {
  color: #94a3b8;
}

.contact-field select {
  appearance: none;
  padding-right: 44px;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 18px center;
}

.contact-field textarea {
  min-height: 140px;
  resize: vertical;
  line-height: 1.55;
}

.contact-field input:not([type="radio"]):hover,
.contact-field select:hover,
.contact-field textarea:hover {
  border-color: #cbd5e1;
}

.contact-field input:not([type="radio"]):focus,
.contact-field select:focus,
.contact-field textarea:focus {
  border-color: var(--primary);
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.1);
}

.contact-field input.invalid,
.contact-field textarea.invalid {
  border-color: rgba(239, 68, 68, 0.65);
  background-color: #fff;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);
}

.contact-error {
  margin-top: 6px;
  font-size: 12.5px;
  color: #dc2626;
}

/* Contact method toggle */
.contact-method {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.contact-segment {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border-radius: 14px;
  background: #eef2f7;
}

.contact-segment-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 10px 22px;
  border-radius: 11px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

/* Out-specify the generic ".contact-field label" rule above. */
.contact-field .contact-segment-option {
  display: inline-flex;
  margin-bottom: 0;
  padding: 10px 22px;
  font-size: 14px;
  color: var(--text-muted);
}

.contact-segment-option svg {
  width: 17px;
  height: 17px;
}

.contact-segment-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.contact-field .contact-segment-option.active {
  background: #ffffff;
  color: var(--primary);
  box-shadow: 0 4px 12px rgba(15, 35, 95, 0.1);
}

.contact-segment-option:has(input:focus-visible) {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* Consent checkbox */
.contact-check {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: #334155;
  line-height: 1.5;
  cursor: pointer;
}

.contact-check input {
  position: absolute;
  opacity: 0;
  width: 20px;
  height: 20px;
  margin: 0;
}

.contact-check-box {
  flex: 0 0 20px;
  height: 20px;
  margin-top: 1px;
  border-radius: 6px;
  border: 1.5px solid #cbd5e1;
  background: #ffffff;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.contact-check input:checked + .contact-check-box {
  border-color: var(--primary);
  background: var(--primary)
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    center / 12px no-repeat;
}

.contact-check input:focus-visible + .contact-check-box {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.contact-check.invalid .contact-check-box {
  border-color: rgba(239, 68, 68, 0.75);
}

.contact-check.invalid span {
  color: #dc2626;
}

/* Submit */
.contact-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 54px;
  border: none;
  border-radius: 999px;
  padding: 14px 24px;
  font-weight: 700;
  font-size: 15.5px;
  font-family: inherit;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  box-shadow: 0 14px 32px rgba(0, 82, 204, 0.3);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.contact-submit svg {
  transition: transform 0.2s ease;
}

.contact-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 18px 40px rgba(0, 82, 204, 0.38);
}

.contact-submit:hover:not(:disabled) svg {
  transform: translateX(3px);
}

.contact-submit:disabled {
  opacity: 0.7;
  cursor: progress;
}

.contact-reassure {
  margin: -6px 0 0;
  text-align: center;
  font-size: 13px;
  color: var(--text-muted);
}

/* Side column */
.contact-side {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-card-info {
  padding: 32px 28px 28px;
  color: #e2e8f0;
  border: none;
  background:
    radial-gradient(380px 220px at 100% 0%, rgba(0, 163, 255, 0.3), transparent 70%),
    linear-gradient(160deg, #13235a, #0f1b3d);
}

.contact-info-eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.contact-card-info h2 {
  margin: 0 0 24px;
  font-size: 22px;
  font-weight: 800;
  color: #ffffff;
}

.contact-info-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
}

.contact-info-line {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 10px;
  margin: 0 -10px;
  border-radius: 14px;
  font-size: 15px;
  line-height: 1.5;
  color: #ffffff;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

a.contact-info-line:hover {
  background: rgba(255, 255, 255, 0.07);
}

.contact-ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  height: 42px;
  border-radius: 12px;
  color: #7dd3fc;
  background: rgba(125, 211, 252, 0.12);
  border: 1px solid rgba(125, 211, 252, 0.18);
}

.contact-info-text {
  display: flex;
  flex-direction: column;
}

.contact-info-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(226, 232, 240, 0.6);
  margin-bottom: 1px;
}

.contact-map-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border-radius: 999px;
  padding: 13px 18px;
  font-weight: 700;
  font-size: 14.5px;
  color: #0f1b3d;
  background: #ffffff;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.contact-map-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
}

/* Map card */
.contact-card-map {
  flex: 1 1;
  min-height: 260px;
  padding: 0;
  overflow: hidden;
}

.contact-map-frame {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 260px;
}

.contact-map-frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

/* Entrance animations */
.contact-animate-left {
  animation: contactRise 0.45s ease both;
}
.contact-animate-right {
  animation: contactRise 0.45s ease both;
  animation-delay: 0.08s;
}
@keyframes contactRise {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .contact-animate-left,
  .contact-animate-right {
    animation: none;
  }
}

/* Responsive */
@media (max-width: 900px) {
  .contact-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .contact-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .contact-hero {
    padding: calc(var(--nav-offset) + 40px) 16px 110px;
  }
  .contact-subtitle {
    font-size: 15.5px;
  }
  .contact-wrap {
    margin-top: -70px;
    padding-bottom: 56px;
  }
  .contact-card-form {
    padding: 26px 20px 24px;
  }
  .contact-card-info {
    padding: 26px 20px 22px;
  }
  .contact-card-map,
  .contact-map-frame {
    min-height: 280px;
  }
}

/* ===========================
   PAGE HERO (shared)
   ===========================
   Navy header for the inner pages (Calculator, Our Team, About). Same look as
   the Contact and service-page headers. */

.page-hero {
  position: relative;
  margin-top: calc(-1 * var(--nav-offset));
  padding: calc(var(--nav-offset) + 64px) 16px 88px;
  color: #ffffff;
  text-align: center;
  background:
    radial-gradient(700px 320px at 15% 0%, rgba(0, 82, 204, 0.55), transparent 70%),
    radial-gradient(600px 300px at 90% 30%, rgba(0, 163, 255, 0.35), transparent 70%),
    #0f1b3d;
  overflow: hidden;
}

.page-hero-overlap {
  padding-bottom: 150px;
}

.page-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse at center, #000 20%, transparent 75%);
  pointer-events: none;
}

.page-hero-inner {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
}

.page-hero-kicker {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 700;
  color: #7dd3fc;
  background: rgba(125, 211, 252, 0.12);
  border: 1px solid rgba(125, 211, 252, 0.25);
  margin-bottom: 18px;
}

.page-hero-title {
  margin: 0 0 14px;
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.page-hero-subtitle {
  margin: 0 auto;
  max-width: 620px;
  font-size: 17px;
  line-height: 1.6;
  color: rgba(226, 232, 240, 0.8);
  text-wrap: balance;
}

.pill-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 900px) {
  .page-hero {
    padding: calc(var(--nav-offset) + 40px) 16px 64px;
  }

  .page-hero-overlap {
    padding-bottom: 110px;
  }

  .page-hero-subtitle {
    font-size: 15.5px;
  }
}

/* ===========================
   CALCULATOR PAGE
   =========================== */

.calc-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px 16px;
  margin-top: 28px;
}

.calc-toolbar .pill-btn {
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.calc-toolbar-note {
  font-size: 14px;
  color: rgba(226, 232, 240, 0.7);
}

.calc-section {
  position: relative;
  max-width: var(--container);
  margin: -100px auto 0;
  padding: 0 16px;
}

.calc-grid {
  display: grid;
  gap: 20px;
  align-items: start;
}

.calc-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.calc-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.calc-card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid rgba(15, 35, 95, 0.06);
  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);
  overflow: hidden;
}

.calc-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  border-bottom: 1px solid #eef2f7;
}

.calc-scenario-name {
  min-width: 0;
  flex: 1 1;
  padding: 6px 10px;
  margin-left: -10px;
  border: 1.5px solid transparent;
  border-radius: 10px;
  background: transparent;
  font-family: inherit;
  font-size: 18px;
  font-weight: 800;
  color: var(--text-main);
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.calc-scenario-name:hover {
  background: #f8fafc;
}

.calc-scenario-name:focus {
  outline: none;
  border-color: var(--primary);
  background: #ffffff;
}

.calc-card-tools {
  display: flex;
  gap: 8px;
}

.calc-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
}

.calc-chip:hover:not(:disabled) {
  border-color: var(--primary);
  color: var(--primary);
}

.calc-chip.danger:hover:not(:disabled) {
  border-color: #ef4444;
  color: #dc2626;
  background: #fef2f2;
}

.calc-chip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.calc-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

/* With a single scenario there is room for inputs and results side by side. */
.calc-grid-1 .calc-form {
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
}

.calc-inputs {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 22px;
}

.calc-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 14px;
}

.calc-field {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.calc-field-wide {
  grid-column: 1 / -1;
}

.calc-field-label {
  display: block;
  padding: 0;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.calc-input-wrap {
  display: flex;
  align-items: center;
  min-height: 48px;
  border-radius: 14px;
  border: 1.5px solid #e2e8f0;
  background: #f8fafc;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.calc-input-wrap:hover {
  border-color: #cbd5e1;
}

.calc-input-wrap:focus-within {
  border-color: var(--primary);
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.1);
}

.calc-affix {
  flex: 0 0 auto;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
}

.calc-affix:first-child {
  padding-right: 0;
}

.calc-affix:last-child {
  padding-left: 0;
}

.calc-input {
  flex: 1 1;
  min-width: 0;
  height: 45px;
  padding: 0 14px 0 8px;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-main);
  font-variant-numeric: tabular-nums;
  outline: none;
}

.calc-input:first-child {
  padding-left: 14px;
}

.calc-segment {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 14px;
  background: #eef2f7;
}

.calc-segment-option {
  position: relative;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 600;
  text-align: center;
  color: var(--text-muted);
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.calc-segment-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.calc-segment-option.active {
  background: #ffffff;
  color: var(--primary);
  box-shadow: 0 4px 12px rgba(15, 35, 95, 0.1);
}

.calc-segment-option:has(input:focus-visible) {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.calc-submit {
  width: 100%;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

/* Results */
.calc-results {
  padding: 24px 22px;
  background: #f8fafc;
  border-top: 1px solid #eef2f7;
}

.calc-grid-1 .calc-results {
  border-top: none;
  border-left: 1px solid #eef2f7;
}

.calc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  min-height: 160px;
  border-radius: 18px;
  border: 1.5px dashed #d5deeb;
  text-align: center;
}

.calc-empty-figure {
  font-size: 30px;
  font-weight: 800;
  color: #cbd5e1;
}

.calc-empty p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
}

.calc-headline {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 22px;
  border-radius: 18px;
  color: #ffffff;
  background:
    radial-gradient(300px 160px at 100% 0%, rgba(0, 163, 255, 0.4), transparent 70%),
    #0f1b3d;
}

.calc-headline-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(226, 232, 240, 0.75);
}

.calc-headline-value {
  font-size: clamp(30px, 3.2vw, 40px);
  font-weight: 800;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
}

.calc-headline-note {
  font-size: 13px;
  color: #7dd3fc;
}

.calc-split {
  margin: 18px 0;
}

.calc-split-bar {
  display: flex;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: #e2e8f0;
}

.calc-split-principal {
  background: var(--primary);
}

.calc-split-interest {
  background: #7dd3fc;
}

.calc-split-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px 12px;
  margin-top: 8px;
  font-size: 12.5px;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.calc-split-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.calc-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.calc-dot-principal {
  background: var(--primary);
}

.calc-dot-interest {
  background: #7dd3fc;
}

.calc-results-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.calc-stat {
  padding: 14px 16px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #eef2f7;
}

.calc-stat-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-muted);
}

.calc-hint {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;
  color: var(--primary);
  background: var(--primary-light);
  cursor: help;
}

.calc-stat-value {
  margin-top: 4px;
  font-size: 17px;
  font-weight: 800;
  color: var(--text-main);
  font-variant-numeric: tabular-nums;
}

.calc-preview {
  margin-top: 16px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #eef2f7;
}

.calc-preview summary {
  padding: 13px 16px;
  font-size: 14px;
  font-weight: 700;
  color: var(--primary);
  cursor: pointer;
}

.calc-table-wrap {
  overflow-x: auto;
  padding: 0 8px 8px;
}

.calc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.calc-table th,
.calc-table td {
  padding: 8px;
  text-align: right;
}

.calc-table th:first-child,
.calc-table td:first-child {
  text-align: left;
}

.calc-table th {
  font-weight: 600;
  color: var(--text-muted);
  border-bottom: 1px solid #eef2f7;
}

.calc-table tbody tr:nth-child(even) {
  background: #f8fafc;
}

.calc-table tr.final td {
  font-weight: 700;
  color: var(--primary);
}

.calc-disclaimer {
  margin: 18px 0 0;
  text-align: center;
  font-size: 13px;
  color: var(--text-muted);
}

@media (max-width: 1100px) {
  .calc-grid-3 {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 900px) {
  .calc-section {
    margin-top: -70px;
  }

  .calc-grid-2 {
    grid-template-columns: minmax(0, 1fr);
  }

  .calc-grid-1 .calc-form {
    grid-template-columns: minmax(0, 1fr);
  }

  .calc-grid-1 .calc-results {
    border-left: none;
    border-top: 1px solid #eef2f7;
  }
}

@media (max-width: 520px) {
  .calc-form-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .calc-inputs,
  .calc-results {
    padding: 20px 16px;
  }
}

/* ===========================
   OUR TEAM PAGE
   =========================== */

.team-section {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 16px;
}

.team-section-lead {
  margin-top: -100px;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
}

.team-card {
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.06);
  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);
}

.team-card-photo {
  position: relative;
  aspect-ratio: 4 / 4.4;
  background: var(--primary-light);
  overflow: hidden;
}

.team-card-photo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 20%;
  transition: transform 0.5s ease;
}

.team-card:hover .team-card-photo img {
  transform: scale(1.03);
}

.team-card-focus {
  position: absolute;
  left: 16px;
  bottom: 16px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #0f1b3d;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
}

.team-card-body {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 24px 24px 28px;
}

.team-card-name {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: var(--text-main);
}

.team-card-role {
  margin: 4px 0 18px;
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary);
}

.team-card-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eef2f7;
}

.team-card-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  transition: color 0.15s ease;
}

.team-card-link svg {
  flex: 0 0 auto;
  padding: 7px;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  color: var(--primary);
  background: var(--primary-light);
}

.team-card-link span {
  overflow-wrap: anywhere;
}

.team-card-link:hover {
  color: var(--primary);
}

.team-card-bio p {
  margin: 0 0 12px;
  font-size: 14.5px;
  line-height: 1.7;
  color: var(--text-muted);
}

.team-card-bio p:last-child {
  margin-bottom: 0;
}

.team-social {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  margin-top: 40px;
  padding: 24px 28px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.07);
}

.team-social-title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: var(--text-main);
}

.team-social-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.team-social-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 8px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  transition: border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.team-social-btn img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

.team-social-btn:hover {
  border-color: var(--primary);
  color: var(--primary);
  transform: translateY(-1px);
}

@media (max-width: 1000px) {
  .team-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .team-section-lead {
    margin-top: -70px;
  }
}

@media (max-width: 640px) {
  .team-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ===========================
   ABOUT PAGE
   =========================== */

.about-section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 72px 16px 0;
}

.about-eyebrow {
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--secondary);
}

.about-eyebrow-light {
  color: #7dd3fc;
}

.about-intro {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 56px;
  align-items: center;
}

.about-lead {
  margin: 0 0 18px;
  font-size: clamp(24px, 2.6vw, 32px);
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-main);
}

.about-body {
  margin: 0;
  font-size: 17px;
  line-height: 1.75;
  color: var(--text-muted);
}

.about-body + .about-body {
  margin-top: 14px;
}

.about-intro-media img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 24px;
  box-shadow: 0 24px 50px rgba(15, 35, 95, 0.15);
}

.about-section-head {
  margin-bottom: 28px;
}

.about-section-title {
  margin: 0;
  font-size: clamp(26px, 2.6vw, 34px);
  font-weight: 800;
  color: var(--text-main);
}

.about-principles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.about-principle {
  padding: 28px 26px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.07);
  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.about-principle:hover {
  transform: translateY(-3px);
  border-color: rgba(0, 82, 204, 0.2);
  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.1);
}

.about-principle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  color: var(--primary);
  background: var(--primary-light);
}

.about-principle h3 {
  margin: 18px 0 8px;
  font-size: 19px;
  font-weight: 800;
  color: var(--text-main);
}

.about-principle p {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: var(--text-muted);
}

.about-director {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  border-radius: 28px;
  overflow: hidden;
  color: #e2e8f0;
  background:
    radial-gradient(500px 280px at 100% 0%, rgba(0, 163, 255, 0.3), transparent 70%),
    #0f1b3d;
  box-shadow: 0 24px 50px rgba(15, 27, 61, 0.22);
}

/* The photo fills its column at whatever height the text sets, instead of
   its own (very tall) natural height setting the card's height. */
.about-director-photo {
  position: relative;
  min-height: 360px;
  background: rgba(255, 255, 255, 0.04);
}

.about-director-photo img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 20%;
}

.about-director-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 44px 48px;
}

.about-director-text h2 {
  margin: 0 0 14px;
  font-size: clamp(26px, 2.6vw, 34px);
  font-weight: 800;
  color: #ffffff;
}

.about-director-text p {
  margin: 0 0 26px;
  font-size: 16.5px;
  line-height: 1.75;
  color: rgba(226, 232, 240, 0.82);
}

@media (max-width: 900px) {
  .about-section {
    padding-top: 52px;
  }

  .about-intro {
    grid-template-columns: minmax(0, 1fr);
    gap: 28px;
  }

  .about-principles {
    grid-template-columns: minmax(0, 1fr);
  }

  .about-director {
    grid-template-columns: minmax(0, 1fr);
  }

  .about-director-photo {
    min-height: 0;
    aspect-ratio: 4 / 3;
  }

  .about-director-text {
    padding: 28px 22px 30px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .team-card-photo img,
  .about-principle {
    transition: none;
  }
}


/* ===========================
   LEGAL PAGES (Privacy, Disclosure)
   ===========================
   Sticky numbered contents beside a white reading card. */

.legal-layout {
  max-width: var(--container);
  margin: 0 auto;
  padding: 56px 16px 80px;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 40px;
  align-items: start;
}

.legal-toc {
  position: sticky;
  top: calc(var(--nav-offset) + 16px);
  max-height: calc(100vh - var(--nav-offset) - 32px);
  overflow-y: auto;
}

.legal-toc-title {
  margin: 0 0 12px;
  padding-left: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--secondary);
}

.legal-toc-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border-left: 2px solid #e2e8f0;
}

.legal-toc-link {
  display: flex;
  gap: 10px;
  margin-left: -2px;
  padding: 7px 12px;
  border-left: 2px solid transparent;
  font-size: 13.5px;
  line-height: 1.45;
  color: var(--text-muted);
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}

.legal-toc-link:hover {
  color: var(--text-main);
}

.legal-toc-link.active {
  border-left-color: var(--primary);
  color: var(--primary);
  font-weight: 600;
  background: linear-gradient(90deg, rgba(0, 82, 204, 0.06), transparent);
}

.legal-toc-number {
  flex: 0 0 18px;
  font-variant-numeric: tabular-nums;
  color: #94a3b8;
}

.legal-toc-link.active .legal-toc-number {
  color: var(--primary);
}

.legal-toc-mobile {
  display: none;
}

.legal-doc {
  min-width: 0;
  padding: 44px 52px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.06);
  box-shadow: 0 10px 30px rgba(15, 35, 95, 0.06);
  font-size: 15.5px;
  line-height: 1.75;
  color: #334155;
}

.legal-section {
  /* Land anchored headings below the floating navbar, not under it. */
  scroll-margin-top: calc(var(--nav-offset) + 16px);
}

.legal-section + .legal-section {
  margin-top: 36px;
  padding-top: 36px;
  border-top: 1px solid #eef2f7;
}

.legal-section-title {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin: 0 0 14px;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 800;
  color: var(--text-main);
}

.legal-section-number {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
  color: var(--primary);
  background: var(--primary-light);
  transform: translateY(-3px);
}

.legal-subhead {
  margin: 24px 0 8px;
  font-size: 17px;
  font-weight: 700;
  color: var(--text-main);
}

.legal-doc p {
  margin: 0 0 14px;
}

.legal-doc ul {
  margin: 0 0 16px;
  padding-left: 22px;
}

.legal-doc li {
  margin-bottom: 8px;
  padding-left: 4px;
}

.legal-doc li::marker {
  color: var(--secondary);
}

.legal-doc a {
  color: var(--primary);
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: rgba(0, 82, 204, 0.3);
  text-underline-offset: 3px;
}

.legal-doc a:hover {
  text-decoration-color: currentColor;
}

.legal-doc strong {
  color: var(--text-main);
}

/* Disclosure: key details */
.legal-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 0 0 40px;
}

.legal-detail {
  padding: 16px 18px;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.legal-detail dt {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.legal-detail dd {
  margin: 4px 0 0;
  font-size: 15.5px;
  font-weight: 700;
  line-height: 1.45;
  color: var(--text-main);
}

/* Disclosure: lender and insurer panels as tags, not 30-line lists */
.legal-doc .legal-chips {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0;
}

.legal-doc .legal-chips li {
  margin: 0;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #1e3a8a;
  background: var(--primary-light);
}

.legal-callout {
  margin: 0 0 14px;
  padding: 18px 20px 4px;
  border-radius: 16px;
  border-left: 4px solid var(--primary);
  background: #f8fafc;
}

.legal-doc .legal-contact-card {
  padding: 18px 20px;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

@media (max-width: 960px) {
  .legal-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
    padding-top: 32px;
  }

  .legal-toc {
    position: static;
    max-height: none;
    overflow: visible;
  }

  .legal-toc-title,
  .legal-toc-desktop {
    display: none;
  }

  .legal-toc-mobile {
    display: block;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid rgba(15, 35, 95, 0.08);
  }

  .legal-toc-mobile summary {
    padding: 14px 18px;
    font-size: 14px;
    font-weight: 700;
    color: var(--primary);
    cursor: pointer;
  }

  .legal-toc-mobile .legal-toc-list {
    margin: 0 18px 14px;
  }

  .legal-doc {
    padding: 28px 20px;
    font-size: 15px;
  }

  .legal-section-title {
    font-size: 19px;
    gap: 10px;
  }

  .legal-details {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ===========================
   CAREERS PAGE
   =========================== */

.careers-section {
  position: relative;
  max-width: 860px;
  margin: -100px auto 0;
  padding: 0 16px 80px;
}

.careers-status {
  padding: 36px 40px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.06);
  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);
}

.careers-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  color: #92400e;
  background: #fef3c7;
}

.careers-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f59e0b;
}

.careers-status h2 {
  margin: 16px 0 10px;
  font-size: clamp(24px, 2.6vw, 30px);
  font-weight: 800;
  color: var(--text-main);
}

.careers-status p {
  margin: 0;
  font-size: 16.5px;
  line-height: 1.7;
  color: var(--text-muted);
}

.careers-status strong {
  color: var(--text-main);
}

.careers-block {
  margin-top: 48px;
}

.careers-heading {
  margin: 0 0 10px;
  font-size: 22px;
  font-weight: 800;
  color: var(--text-main);
}

.careers-text {
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 1.7;
  color: var(--text-muted);
}

.careers-text a {
  color: var(--primary);
  font-weight: 600;
}

.careers-text strong {
  color: var(--text-main);
}

.careers-steps {
  list-style: none;
  margin: 20px 0;
  padding: 0;
  display: grid;
  gap: 12px;
}

.careers-step {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.07);
  font-size: 15.5px;
  line-height: 1.55;
  color: var(--text-main);
}

.careers-step-number {
  flex: 0 0 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-weight: 800;
  color: var(--primary);
  background: var(--primary-light);
}

.careers-email {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  padding: 24px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(0, 82, 204, 0.06), rgba(0, 163, 255, 0.06));
  border: 1px solid rgba(0, 82, 204, 0.12);
}

.careers-email > div {
  flex: 1 1 320px;
}

.careers-email .careers-text {
  margin: 0;
}

@media (max-width: 900px) {
  .careers-section {
    margin-top: -70px;
    padding-bottom: 56px;
  }

  .careers-status {
    padding: 26px 22px;
  }

  .careers-email {
    padding: 20px;
  }
}

/* ===========================
   HOME HERO
   =========================== */

.hero {
  position: relative;
  margin-top: calc(-1 * var(--nav-offset));
  padding: calc(var(--nav-offset) + 72px) 16px 96px;
  color: #ffffff;
  background:
    linear-gradient(100deg, rgba(10, 20, 48, 0.94) 0%, rgba(10, 20, 48, 0.82) 45%, rgba(10, 20, 48, 0.45) 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center / cover no-repeat;
  overflow: hidden;
}

/* Soft blue glow so the left side isn't a flat block of navy */
.hero::before {
  content: "";
  position: absolute;
  inset: auto auto -30% -10%;
  width: 60%;
  height: 90%;
  background: radial-gradient(closest-side, rgba(0, 82, 204, 0.45), transparent);
  pointer-events: none;
}

.hero-inner {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.85fr);
  gap: 56px;
  align-items: center;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(8px);
}

.hero-badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.2);
}

.hero-title {
  margin: 22px 0 18px;
  font-size: clamp(38px, 5vw, 64px);
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #ffffff;
}

.hero-highlight {
  background: linear-gradient(90deg, #60a5fa, #38bdf8);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hero-punchline {
  margin: 0;
  max-width: 540px;
  font-size: 18px;
  line-height: 1.6;
  color: rgba(226, 232, 240, 0.88);
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 32px;
}

.hero-usp-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  margin: 28px 0 0;
  padding: 0;
  list-style: none;
}

.hero-usp-row li {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(226, 232, 240, 0.85);
}

.hero-usp-row svg {
  flex: 0 0 auto;
  padding: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #0f1b3d;
  background: #7dd3fc;
}

/* Glass "how it works" card */
.hero-steps {
  padding: 28px 26px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(14px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
}

.hero-steps-title {
  margin: 0 0 18px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.hero-steps ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.hero-step {
  position: relative;
  display: flex;
  gap: 16px;
  padding-bottom: 22px;
}

.hero-step:last-child {
  padding-bottom: 0;
}

/* Line joining the step numbers */
.hero-step:not(:last-child)::before {
  content: "";
  position: absolute;
  top: 38px;
  bottom: 4px;
  left: 17px;
  width: 2px;
  border-radius: 2px;
  background: rgba(125, 211, 252, 0.25);
}

.hero-step-number {
  flex: 0 0 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 15px;
  font-weight: 800;
  color: #0f1b3d;
  background: linear-gradient(135deg, #ffffff, #bae6fd);
}

.hero-step-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-top: 6px;
}

.hero-step-body strong {
  font-size: 16px;
  line-height: 1.35;
  color: #ffffff;
}

.hero-step-body span {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(226, 232, 240, 0.75);
}

@media (max-width: 960px) {
  .hero {
    padding: calc(var(--nav-offset) + 40px) 16px 64px;
  }

  .hero-inner {
    grid-template-columns: minmax(0, 1fr);
    gap: 36px;
  }

  .hero-punchline {
    font-size: 16.5px;
  }
}

/* ===========================
   CLIENT REVIEWS
   =========================== */

.reviews-section {
  position: relative;
  padding: 88px 16px;
  color: #ffffff;
  background:
    radial-gradient(700px 360px at 0% 0%, rgba(0, 82, 204, 0.4), transparent 70%),
    radial-gradient(600px 360px at 100% 100%, rgba(0, 163, 255, 0.22), transparent 70%),
    #0b1531;
  overflow: hidden;
}

.reviews-inner {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
}

.reviews-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px 32px;
  margin-bottom: 40px;
}

.reviews-kicker {
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.reviews-title {
  margin: 0;
  max-width: 560px;
  font-size: clamp(28px, 3.2vw, 42px);
  line-height: 1.15;
  font-weight: 800;
  color: #ffffff;
}

/* One row that drifts left forever, like the bank logos. Two copies of the
   list sit in the track; it moves by exactly one copy (-50%) and restarts.
   Spacing is margin on each card rather than flex gap, so both halves are
   identical and the restart is seamless. */
.reviews-marquee {
  position: relative;
  overflow: hidden;
  padding: 6px 0 10px;
  /* fade the cards in and out at the screen edges */
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}

.reviews-track {
  display: flex;
  width: max-content;
  animation: reviews-scroll 60s linear infinite;
}

/* Hold still while someone is reading a card */
.reviews-marquee:hover .reviews-track {
  animation-play-state: paused;
}

@keyframes reviews-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.review-card {
  display: flex;
  flex-direction: column;
  flex: 0 0 360px;
  margin: 0 20px 0 0;
  padding: 26px 24px 22px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.review-card:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(125, 211, 252, 0.3);
}

.review-stars {
  display: inline-flex;
  gap: 2px;
  color: #fbbf24;
}

.review-text {
  position: relative;
  margin: 14px 0 20px;
  font-size: 16px;
  line-height: 1.65;
  color: rgba(241, 245, 249, 0.92);
}

.review-author {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.review-avatar {
  flex: 0 0 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 800;
  color: #0f1b3d;
  background: linear-gradient(135deg, #bae6fd, #60a5fa);
}

.review-name {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}

.review-tag {
  display: block;
  font-size: 13px;
  color: rgba(226, 232, 240, 0.6);
}

@media (max-width: 900px) {
  .reviews-section {
    padding: 60px 16px;
  }

  .reviews-head {
    margin-bottom: 28px;
  }

  .review-card {
    flex-basis: 300px;
    margin-right: 14px;
  }
}

/* ===========================
   LOCATION (home)
   =========================== */

.location-section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 80px 16px;
}

.location-head {
  max-width: 640px;
  margin: 0 auto 36px;
  text-align: center;
}

.location-kicker {
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--secondary);
}

.location-title {
  margin: 0 0 12px;
  font-size: clamp(28px, 3vw, 38px);
  line-height: 1.2;
  font-weight: 800;
  color: var(--text-main);
}

.location-subtitle {
  margin: 0;
  font-size: 16px;
  line-height: 1.65;
  color: var(--text-muted);
}

/* One card: details on the left, the map filling the right */
.location-panel {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  border-radius: 28px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 95, 0.06);
  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.1);
}

.location-info {
  display: flex;
  flex-direction: column;
  padding: 40px 40px 36px;
}

.location-address-block {
  display: flex;
  gap: 16px;
}

.location-pin {
  flex: 0 0 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: #ffffff;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  box-shadow: 0 10px 22px rgba(0, 82, 204, 0.3);
}

.location-name {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 800;
  color: var(--text-main);
}

.location-address {
  margin: 0;
  font-size: 15.5px;
  line-height: 1.6;
  color: #334155;
}

.location-note {
  margin: 24px 0;
  padding: 14px 16px;
  border-radius: 14px;
  font-size: 14.5px;
  line-height: 1.6;
  color: #334155;
  background: #f1f6ff;
  border: 1px solid rgba(0, 82, 204, 0.1);
}

.location-points {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 0 28px;
  padding: 0;
  list-style: none;
}

.location-points li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: var(--text-main);
}

.location-point-icon {
  flex: 0 0 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: var(--primary);
  background: var(--primary-light);
}

.location-point-icon svg {
  width: 18px;
  height: 18px;
}

.location-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  margin-top: auto;
}

.location-link {
  font-size: 15px;
  font-weight: 700;
  color: var(--primary);
}

.location-link:hover {
  text-decoration: underline;
}

.location-map {
  position: relative;
  min-height: 460px;
  background: #e8eef7;
}

.location-map iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 900px) {
  .location-section {
    padding: 56px 16px;
  }

  .location-panel {
    grid-template-columns: minmax(0, 1fr);
  }

  .location-info {
    padding: 28px 22px 26px;
  }

  .location-map {
    min-height: 320px;
  }
}

/* No auto-motion for people who ask for less: the strip becomes a row they
   can swipe or scroll themselves. */
@media (prefers-reduced-motion: reduce) {
  .reviews-track {
    animation: none;
  }

  .reviews-marquee {
    overflow-x: auto;
  }

  .review-card {
    transition: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,eAAe;EACf;;;mEAGiE;EACjE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,iDAAiD;EACjD,iBAAiB;;EAEjB;;;;gFAI8E;EAC9E,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iFAAiF;EACjF,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,8BAA8B,EAAE,+BAA+B;AACjE;;;AAGA;;gCAEgC;;AAEhC;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kCAAkC;EAClC,cAAc;AAChB;;AAEA,2CAA2C;;AAE3C;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;gCAEgC;;AAEhC;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;gCAEgC;;AAEhC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,gCAAgC;EAChC;;;WAGS;AACX;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iFAAiF;AACnF;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mFAAmF;AACrF;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,oBAAoB;EACpB,+CAA+C;EAC/C,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;qEACqE;AACrE;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;gCAEgC;;AAEhC;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF;;AAEA;;;;mBAImB;;AAEnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;qFAEmF;AACrF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAE3C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,aAAa;EACf;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;EAC7C,wDAAwD;AAC1D;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,MAAM;EACR;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;+CAQ+C;;AAE/C;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;iDACiD;AACjD;;;EAGE,0BAA0B;EAC1B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;;yBAIyB;;AAEzB;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,wCAAwC;EACxC,iDAAiD;EACjD,cAAc;EACd;;;WAGS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,0EAA0E;EAC1E,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qEAAqE;EACrE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qEAAqE;EACrE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;iDACiD;AACjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd;;;WAGS;EACT,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;IAKE,gBAAgB;EAClB;AACF;;AAEA;;;;gCAIgC;;AAEhC;EACE,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qEAAqE;EACrE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;4DAE4D;AAC5D;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EAEV,2BAA2B;EAE3B,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;EAErC,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C;2BACyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,4BAA4B;;AAE5B;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;EAEE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,2CAA2C;;AAE3C;8EAC8E;AAC9E;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,sEAAsE;AACxE;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;iCACiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;uEAEuE;AACvE;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sDAAsD;AACxD;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;AACf;;AAEA,2BAA2B;;AAE3B;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,2CAA2C;;AAE3C;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,mEAAmE;IACnE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,SAAO;EACT;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;iDACiD;AACjD;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;IAIE,sCAAsC;EACxC;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,kBAAkB;AACpB;;AAEA;mEACmE;AACnE;EACE,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd;;;WAGS;EACT,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qEAAqE;EACrE,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;EAC7C,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;oDACoD;AACpD;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE;;;IAGE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;;AAExC;EACE;;;IAGE,cAAc;IACd,sBAAsB;EACxB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;;;IAGE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;;IAGE,kBAAkB;EACpB;AACF;;AAEA;;;;;;yCAMyC;;AAEzC;EACE,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;EAClC;wDACsD;EACtD,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;qCACqC;AACrC;;;EAGE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;6CAE6C;AAC7C;;;EAGE,gBAAgB;AAClB;;AAEA;kEACkE;AAClE;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;yEACyE;AACzE;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,mFAAmF;AACrF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,oEAAoE;AACtE;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;EACxB,qBAAqB;EACrB,6CAA6C;EAC7C,eAAe;EACf;qEACmE;AACrE;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;yDACuD;EACvD;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;;iEAIiE;;AAEjE;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,kDAAkD;EAClD,cAAc;EACd;;;WAGS;EACT,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,uFAAuF;EACvF,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,4BAA4B;EAC5B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;EAEE,qCAAqC;EACrC,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,6EAA6E;AAC/E;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,4BAA4B;EAC5B;;2BAEyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,qEAAqE;EACrE,6CAA6C;EAC7C,0EAA0E;AAC5E;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ;;6CAE2C;AAC7C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,aAAa;AACb;EACE,SAAO;EACP,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kDAAkD;EACpD;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;;;0CAI0C;;AAE1C;EACE,kBAAkB;EAClB,wCAAwC;EACxC,iDAAiD;EACjD,cAAc;EACd,kBAAkB;EAClB;;;WAGS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA,8EAA8E;AAC9E;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd;;WAES;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EAEpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;EAC7C,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd;;WAES;EACT,8CAA8C;AAChD;;AAEA;kEACkE;AAClE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;;AAGA;;;0DAG0D;;AAE1D;EACE,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,kFAAkF;AACpF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,uEAAuE;AACzE;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;EAC9C,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oFAAoF;EACpF,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,wCAAwC;EACxC,iDAAiD;EACjD,cAAc;EACd;;oEAE8D;EAC9D,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,8EAA8E;EAC9E,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAE3C,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAE3C,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;;;WAGS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;2CAG2C;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAElD,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,+CAA+C;AAC/C;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,mFAAmF;AACrF;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,qEAAqE;EACrE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;oCACoC;AACpC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  max-width: 100%;\n  /* Prevent sideways scroll from wide sections. `clip` rather than `hidden`:\n     hidden on both html and body turns body into a scroll container, which\n     silently stops every position: sticky element on the site from sticking.\n     Older browsers that don't know `clip` fall back to `hidden`. */\n  overflow-x: hidden;\n  overflow-x: clip;\n}\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n:root {\n  --primary: #0052cc;\n  --primary-light: #e6f0ff;\n  --secondary: #00a3ff;\n  --accent: #0f9d58;\n  --text-main: #1b1f3b;\n  --text-muted: #5f6473;\n  --bg: #f5f7fb;\n  --white: #ffffff;\n  --shadow-soft: 0 10px 30px rgba(15, 35, 95, 0.08);\n  --radius-lg: 18px;\n\n  /* Layout — one content column for the whole site.\n     --container       : standard page width (cards, grids, service pages)\n     --container-narrow: long-form reading measure (About, Privacy, Disclosure)\n     --gutter          : minimum breathing room at the viewport edge\n     Replaces ten separate max-widths (620/720/780/800/860/900/980/1100/1120). */\n  --container: 1120px;\n  --container-narrow: 720px;\n  --gutter: 24px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  background-color: var(--bg);\n  color: var(--text-main);\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-content {\n  flex: 1;\n  padding-top: var(--nav-offset); /* clears the floating navbar */\n}\n\n\n/* ===========================\n   LAYOUT HELPERS / SECTIONS\n   =========================== */\n\n.section {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 40px 16px;\n}\n\n.section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 24px;\n  align-items: center;\n  text-align: center;\n}\n\n.section-title {\n  font-size: clamp(26px, 3vw, 32px);\n  margin: 0;\n  font-weight: 700;\n}\n\n.section-subtitle {\n  font-size: 15px;\n  color: var(--text-muted);\n  max-width: var(--container-narrow);\n  margin: 0 auto;\n}\n\n/* Shared buttons and cards (older pages) */\n\n.btn-primary,\n.btn-outline {\n  border-radius: 999px;\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  color: var(--white);\n  box-shadow: var(--shadow-soft);\n}\n\n.btn-outline {\n  background: transparent;\n  border: 1px solid #d9e2ff;\n  color: var(--primary);\n}\n\n/* Cards & grids */\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n@media (max-width: 900px) {\n  .card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .card-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.card {\n  background: var(--white);\n  border-radius: var(--radius-lg);\n  padding: 18px;\n  box-shadow: var(--shadow-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.card-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: var(--primary-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.card-title {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.card-text {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.card-link {\n  font-size: 12px;\n  color: var(--primary);\n  margin-top: auto;\n}\n\n/* ===========================\n   LOAN CALCULATOR\n   =========================== */\n\n.calculator-wrapper {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n  gap: 28px;\n}\n\n.calculator-card {\n  background: var(--white);\n  border-radius: var(--radius-lg);\n  padding: 18px;\n  box-shadow: var(--shadow-soft);\n}\n\n.form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\nlabel {\n  font-size: 13px;\n  font-weight: 500;\n}\n\ninput,\ntextarea {\n  border-radius: 10px;\n  border: 1px solid #d1d9ec;\n  padding: 8px 10px;\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  font-family: inherit;\n}\n\ninput:focus,\ntextarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 1px rgba(0, 82, 204, 0.16);\n}\n\ntextarea {\n  min-height: 90px;\n  resize: vertical;\n}\n\n.result-box {\n  margin-top: 12px;\n  padding: 10px;\n  border-radius: 10px;\n  background: var(--primary-light);\n  font-size: 13px;\n}\n\n/* ===========================\n   SUBNAV (About / service pages)\n   =========================== */\n\n.subnav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.subnav a {\n  font-size: 12px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid #d9e2ff;\n  color: var(--text-muted);\n}\n\n.subnav a:hover {\n  border-color: var(--primary);\n  color: var(--primary);\n}\n\n/* ===========================\n   FOOTER\n   =========================== */\n\n.footer {\n  position: relative;\n  margin-top: 0;\n  padding: 64px 16px 0;\n  color: rgba(226, 232, 240, 0.75);\n  background:\n    radial-gradient(600px 300px at 0% 0%, rgba(0, 82, 204, 0.28), transparent 70%),\n    radial-gradient(500px 280px at 100% 100%, rgba(0, 163, 255, 0.14), transparent 70%),\n    #070e24;\n}\n\n/* Thin gradient rule along the top edge */\n.footer::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--primary), var(--secondary), transparent);\n}\n\n.footer-inner {\n  max-width: var(--container);\n  margin: 0 auto;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) repeat(4, minmax(0, 1fr));\n  gap: 40px 32px;\n  padding-bottom: 40px;\n}\n\n.footer-logo {\n  display: inline-flex;\n  padding: 10px 14px;\n  border-radius: 14px;\n  background: #ffffff;\n}\n\n.footer-logo img {\n  display: block;\n  height: 34px;\n  width: auto;\n}\n\n.footer-about {\n  margin: 18px 0 22px;\n  max-width: 340px;\n  font-size: 14.5px;\n  line-height: 1.65;\n}\n\n.footer-contact-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  margin: 0 0 28px;\n  padding: 0;\n  list-style: none;\n}\n\n.footer-contact-row li {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  padding: 16px 18px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 14.5px;\n  line-height: 1.45;\n}\n\n.footer-contact-row li > span:last-child {\n  min-width: 0;\n}\n\n.footer-contact-label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(226, 232, 240, 0.5);\n}\n\n.footer-contact-row address {\n  font-style: normal;\n  color: #ffffff;\n}\n\n.footer-contact-row a {\n  color: #ffffff;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.footer-contact-row a:hover {\n  color: #7dd3fc;\n}\n\n.footer-contact-icon {\n  flex: 0 0 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  color: #7dd3fc;\n  background: rgba(125, 211, 252, 0.1);\n  border: 1px solid rgba(125, 211, 252, 0.15);\n}\n\n.footer-social {\n  display: flex;\n  gap: 10px;\n}\n\n.footer-social-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.footer-social-link:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(125, 211, 252, 0.4);\n}\n\n.footer-social-link:focus-visible {\n  outline: 2px solid #7dd3fc;\n  outline-offset: 2px;\n}\n\n.footer-social-link img {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n}\n\n.footer-heading {\n  margin: 8px 0 18px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #ffffff;\n}\n\n.footer-list {\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 14.5px;\n}\n\n.footer-list a {\n  color: rgba(226, 232, 240, 0.75);\n  transition: color 0.15s ease, padding-left 0.2s ease;\n}\n\n.footer-list a:hover {\n  color: #ffffff;\n  padding-left: 4px;\n}\n\n.footer-bottom {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px 24px;\n  padding: 22px 0 26px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 13px;\n  color: rgba(226, 232, 240, 0.55);\n}\n\n.footer-bottom p {\n  margin: 0;\n}\n\n.footer-legal {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 22px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.footer-legal a {\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.footer-legal a:hover {\n  color: #ffffff;\n}\n\n/* Tablet: brand across the top, all four link columns in one row, and the\n   address tile full width with call + email side by side under it. */\n@media (max-width: 1000px) {\n  .footer-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n  }\n\n  .footer-contact-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-contact-row li:first-child {\n    grid-column: 1 / -1;\n  }\n}\n\n/* Phone: two link columns, contact tiles stacked */\n@media (max-width: 640px) {\n  .footer-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-contact-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 520px) {\n  .footer {\n    padding-top: 48px;\n  }\n\n  .footer-grid {\n    gap: 32px 20px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .footer-social-link,\n  .footer-list a {\n    transition: none;\n  }\n}\n\n/* ===========================\n   CAROUSEL (older image/text carousel)\n   =========================== */\n\n.carousel {\n  position: relative;\n  border-radius: var(--radius-lg);\n  background: var(--white);\n  box-shadow: var(--shadow-soft);\n  padding: 18px;\n  overflow: hidden;\n}\n\n.carousel-inner {\n  position: relative;\n  min-height: 220px;\n}\n\n.carousel-slide {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.1fr);\n  gap: 20px;\n  align-items: center;\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transform: translateX(20px);\n  transition: opacity 0.35s ease, transform 0.35s ease;\n  pointer-events: none;\n}\n\n.carousel-slide.active {\n  opacity: 1;\n  transform: translateX(0);\n  pointer-events: auto;\n  position: relative;\n}\n\n.carousel-img-wrapper {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.carousel-img {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n  display: block;\n}\n\n.carousel-content h3 {\n  margin: 0 0 8px;\n  font-size: 20px;\n}\n\n.carousel-content p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.carousel-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 999px;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: rgba(15, 23, 42, 0.06);\n  cursor: pointer;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel-arrow.left {\n  left: 10px;\n}\n\n.carousel-arrow.right {\n  right: 10px;\n}\n\n.carousel-arrow:hover {\n  background: rgba(15, 23, 42, 0.12);\n}\n\n.carousel-dots {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.carousel-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  border: none;\n  background: #d1d5db;\n  cursor: pointer;\n}\n\n.carousel-dot.active {\n  width: 18px;\n  background: var(--primary);\n}\n\n@media (max-width: 800px) {\n  .carousel-slide {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .carousel-img {\n    height: 180px;\n  }\n}\n\n/* ===========================\n   IMAGE STRIP\n   =========================== */\n\n.image-strip {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.image-strip-item {\n  background: var(--white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.image-strip-photo {\n  height: 150px;\n  background-size: cover;\n  background-position: center;\n}\n\n.image-strip-photo-1 {\n  background-image: url(\"https://via.placeholder.com/400x250?text=First+Home\");\n}\n\n.image-strip-photo-2 {\n  background-image: url(\"https://via.placeholder.com/400x250?text=Refinance\");\n}\n\n.image-strip-photo-3 {\n  background-image: url(\"https://via.placeholder.com/400x250?text=Investment+%26+Business\");\n}\n\n.image-strip-caption {\n  padding: 10px 12px;\n  font-size: 13px;\n  color: var(--text-main);\n}\n\n@media (max-width: 900px) {\n  .image-strip {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .image-strip {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ===========================\n   BANK LOGOS – STATIC\n   =========================== */\n\n.bank-logos-section {\n  padding-bottom: 50px;\n}\n\n.bank-logos-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  align-items: center;\n}\n\n.bank-logo-card {\n  flex: 0 0 auto;\n  padding: 10px 16px;\n  border-radius: 999px;\n  background: var(--white);\n  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bank-logo-card img {\n  max-width: 90px;\n  max-height: 32px;\n  object-fit: contain;\n  filter: grayscale(100%);\n  opacity: 0.9;\n}\n\n.bank-logo-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.bank-logos-note {\n  margin-top: 12px;\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n/* ===========================\n   BANK LOGOS – INFINITE STRIP\n   =========================== */\n\n.bank-marquee-section {\n  width: 100%;\n  padding: 12px 0 8px;\n  background: transparent;\n}\n\n.bank-marquee-label {\n  font-size: 20px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #0c2f7a;\n  font-weight: 750;\n  text-align: center;\n  margin: 0 0 10px 0;\n}\n\n.bank-marquee {\n  overflow: hidden;\n}\n\n.bank-marquee-inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 40px;\n  white-space: nowrap;\n  will-change: transform;\n  animation: bank-scroll 40s linear infinite;\n}\n\n.bank-marquee-item {\n  flex: 0 0 auto;\n}\n\n.bank-marquee-item img {\n  height: 80px;\n  width: auto;\n  object-fit: contain;\n}\n\n@keyframes bank-scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n@media (max-width: 640px) {\n  .bank-marquee-label {\n    margin-left: 12px;\n  }\n  .bank-marquee-item img {\n    height: 36px;\n  }\n}\n\n/* ===========================\n   TRUSTED ADVISORS VIDEO\n   ===========================\n   Video stays as the background; a navy tint keeps it on-brand and the\n   text readable. */\n\n.trust-section {\n  position: relative;\n  overflow: hidden;\n  color: #ffffff;\n  background: #0b1531;\n}\n\n.trust-video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.trust-overlay {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(100deg, rgba(8, 16, 40, 0.92) 0%, rgba(8, 16, 40, 0.72) 50%, rgba(8, 16, 40, 0.38) 100%),\n    radial-gradient(600px 300px at 10% 100%, rgba(0, 82, 204, 0.35), transparent 70%);\n}\n\n.trust-inner {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 96px 16px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.3fr) minmax(0, 0.9fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.trust-kicker {\n  display: block;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.trust-title {\n  margin: 0 0 20px;\n  font-size: clamp(30px, 3.6vw, 46px);\n  line-height: 1.12;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: #ffffff;\n}\n\n.trust-text {\n  margin: 0 0 14px;\n  max-width: 580px;\n  font-size: 16.5px;\n  line-height: 1.75;\n  color: rgba(226, 232, 240, 0.85);\n}\n\n.trust-copy .pill-btn {\n  margin-top: 16px;\n}\n\n.trust-facts {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.trust-fact {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 22px 24px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  -webkit-backdrop-filter: blur(12px);\n  backdrop-filter: blur(12px);\n}\n\n.trust-fact-value {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  width: 132px;\n  font-size: 32px;\n  line-height: 1;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  background: linear-gradient(90deg, #ffffff, #7dd3fc);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.trust-fact-label {\n  font-size: 14.5px;\n  line-height: 1.5;\n  color: rgba(226, 232, 240, 0.85);\n}\n\n@media (max-width: 900px) {\n  .trust-inner {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 32px;\n    padding: 64px 16px;\n  }\n\n  .trust-text {\n    font-size: 15.5px;\n  }\n\n  .trust-fact-value {\n    width: auto;\n    min-width: 72px;\n    font-size: 26px;\n  }\n}\n\n/* Reduced motion: no moving background, the navy shows instead */\n@media (prefers-reduced-motion: reduce) {\n  .trust-video {\n    display: none;\n  }\n}\n\n/* ===========================\n   HOME ABOUT US\n   =========================== */\n\n.about-home-section {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 88px 16px;\n}\n\n.about-home-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.about-home-kicker {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--secondary);\n}\n\n.about-home-title {\n  margin: 0 0 16px;\n  font-size: clamp(28px, 3.2vw, 40px);\n  line-height: 1.15;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.about-home-lead {\n  margin: 0 0 28px;\n  font-size: 17px;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n.about-home-points {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.about-home-point {\n  display: flex;\n  gap: 18px;\n  padding: 20px 22px;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.about-home-point:hover {\n  border-color: rgba(0, 82, 204, 0.2);\n  box-shadow: 0 14px 30px rgba(15, 35, 95, 0.08);\n}\n\n.about-home-point-number {\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--primary);\n  font-variant-numeric: tabular-nums;\n  padding-top: 2px;\n}\n\n.about-home-point h3 {\n  margin: 0 0 6px;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.about-home-point p {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.65;\n  color: var(--text-muted);\n}\n\n.about-home-card {\n  overflow: hidden;\n  border-radius: 24px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.06);\n  box-shadow: 0 24px 50px rgba(15, 35, 95, 0.12);\n}\n\n.about-home-photo img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n}\n\n.about-home-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 24px 26px 26px;\n}\n\n.about-home-stat-number {\n  font-size: 20px;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.about-home-stat-label {\n  margin-bottom: 14px;\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--text-muted);\n}\n\n@media (max-width: 900px) {\n  .about-home-section {\n    padding: 56px 16px;\n  }\n\n  .about-home-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 32px;\n  }\n\n  .about-home-lead {\n    font-size: 16px;\n  }\n\n  .about-home-point {\n    padding: 18px;\n    gap: 14px;\n  }\n}\n\n/* ===========================\n   “Our Services” THREE-CARD\n   =========================== */\n\n.services-section {\n  padding-top: 36px;\n  padding-bottom: 40px;\n}\n\n.services-carousel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 18px;\n  margin-top: 8px;\n}\n\n.services-card {\n  background: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  padding: 16px 18px;\n  width: 260px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  transition: transform 0.35s ease, opacity 0.35s ease, box-shadow 0.35s ease;\n}\n\n.services-card-center {\n  transform: scale(1);\n  opacity: 1;\n  z-index: 2;\n  box-shadow: 0 18px 35px rgba(15, 23, 42, 0.18);\n}\n\n.services-card-side {\n  transform: scale(0.9);\n  opacity: 0.75;\n  z-index: 1;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08);\n}\n\n.services-card-left {\n  transform: translateX(-20px) scale(0.9);\n}\n\n.services-card-right {\n  transform: translateX(20px) scale(0.9);\n}\n\n.services-card-icon {\n  font-size: 24px;\n  margin-bottom: 4px;\n}\n\n.services-card-category {\n  font-size: 11px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--secondary);\n  font-weight: 700;\n}\n\n.services-card-title {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.services-card-subtitle {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.services-slide-in-left {\n  animation: services-slide-left 0.45s ease;\n}\n\n.services-slide-in-right {\n  animation: services-slide-right 0.45s ease;\n}\n\n@keyframes services-slide-left {\n  from {\n    opacity: 0;\n    transform: translateX(-35px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n@keyframes services-slide-right {\n  from {\n    opacity: 0;\n    transform: translateX(35px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n@media (max-width: 900px) {\n  .services-carousel {\n    gap: 10px;\n  }\n\n  .services-card {\n    width: 220px;\n    padding: 14px 14px;\n  }\n}\n\n@media (max-width: 640px) {\n  .services-carousel {\n    gap: 0;\n  }\n\n  .services-card-side {\n    display: none;\n  }\n\n  .services-card-center {\n    width: 100%;\n  }\n}\n\n/* ===========================\n   LOAN SERVICES – INFINITE LOOP\n   =========================== */\n\n.loan-services-section {\n  padding: 40px 0;\n  width: 100vw;\n  max-width: none;\n  margin: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.section.loan-services-section {\n  max-width: none;\n  margin: 0;\n}\n\n.loan-loop-card {\n  display: flex;\n  flex: 0 0 640px;\n  background: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  overflow: hidden;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  cursor: pointer;\n}\n\n.loan-loop-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.16);\n}\n\n.loan-card-image {\n  flex: 0 0 50%;\n}\n\n.loan-card-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: contain;\n}\n\n.loan-card-content {\n  flex: 1;\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.loan-card-tag {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--secondary);\n  font-weight: 700;\n}\n\n.loan-card-title {\n  font-size: 20px;\n  margin: 0;\n  font-weight: 700;\n}\n\n.loan-card-description {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0 0 8px;\n}\n\n.loan-card-link {\n  margin-top: auto;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.loan-card-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 900px) {\n  .loan-loop-card {\n    flex: 0 0 90vw;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .loan-loop-card {\n    flex: 0 0 360px;\n  }\n}\n\n/* ===========================\n   PROTECTION SERVICES – LOOP\n   =========================== */\n\n.protection-services-section {\n  padding: 40px 0;\n  width: 100vw;\n  max-width: none;\n  margin: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.section.protection-services-section {\n  max-width: none;\n  margin: 0;\n}\n\n.protection-loop-card {\n  display: flex;\n  flex: 0 0 640px;\n  background: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  overflow: hidden;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  cursor: pointer;\n}\n\n.protection-loop-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.16);\n}\n\n.protection-card-image {\n  flex: 0 0 50%;\n}\n\n.protection-card-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: contain;\n}\n\n.protection-card-content {\n  flex: 1;\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.protection-card-tag {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--secondary);\n  font-weight: 700;\n}\n\n.protection-card-title {\n  font-size: 20px;\n  margin: 0;\n  font-weight: 700;\n}\n\n.protection-card-description {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0 0 8px;\n}\n\n.protection-card-link {\n  margin-top: auto;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.protection-card-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 900px) {\n  .protection-loop-card {\n    flex: 0 0 90vw;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .protection-loop-card {\n    flex: 0 0 360px;\n  }\n}\n\n/* ===========================\n   BUSINESS SERVICES – LOOP\n   =========================== */\n\n.business-services-section {\n  padding: 40px 0;\n  width: 100vw;\n  max-width: none;\n  margin: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.section.business-services-section {\n  max-width: none;\n  margin: 0;\n}\n\n.business-loop-card {\n  display: flex;\n  flex: 0 0 640px;\n  background: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  overflow: hidden;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  cursor: pointer;\n}\n\n.business-loop-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.16);\n}\n\n.business-card-image {\n  flex: 0 0 50%;\n}\n\n.business-card-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: contain;\n}\n\n.business-card-content {\n  flex: 1;\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.business-card-tag {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--secondary);\n  font-weight: 700;\n}\n\n.business-card-title {\n  font-size: 20px;\n  margin: 0;\n  font-weight: 700;\n}\n\n.business-card-description {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0 0 8px;\n}\n\n.business-card-link {\n  margin-top: auto;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.business-card-link:hover {\n  text-decoration: underline;\n}\n\n/* ===========================\n   WHOLE-CARD CLICK TARGET\n   ===========================\n   The service cards already looked clickable (cursor: pointer) but only the\n   \"Learn more\" link actually went anywhere. Rather than putting an onClick on\n   the card div, we stretch the existing link over the whole card with a\n   pseudo-element. That keeps one real <a> per card, so keyboard tabbing,\n   cmd/ctrl-click, middle-click and \"open in new tab\" all keep working, and the\n   destination stays in one place in the JSX. */\n\n.loan-loop-card,\n.protection-loop-card,\n.business-loop-card {\n  position: relative;\n}\n\n.loan-card-link::after,\n.protection-card-link::after,\n.business-card-link::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n}\n\n/* The card is now the focus target, so show the focus ring around the card\n   rather than around a few words of link text. */\n.loan-card-link:focus-visible::after,\n.protection-card-link:focus-visible::after,\n.business-card-link:focus-visible::after {\n  outline: 2px solid #2563eb;\n  outline-offset: -2px;\n  border-radius: var(--radius-lg);\n}\n\n@media (max-width: 900px) {\n  .business-loop-card {\n    flex: 0 0 520px;\n  }\n}\n\n@media (max-width: 640px) {\n  .business-loop-card {\n    flex: 0 0 90vw;\n    flex-direction: column;\n  }\n}\n\n/* Pill button used by the Location section. */\n.primary-btn {\n  margin-top: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 22px;\n  border-radius: 999px;\n  border: none;\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  box-shadow: 0 16px 40px rgba(37, 99, 235, 0.45);\n}\n\n.primary-btn:hover {\n  filter: brightness(1.05);\n  transform: translateY(-1px);\n}\n\n/* ===========================\n   SERVICE PAGES (/services/:id)\n   ===========================\n   Same language as the Contact page: navy hero behind the floating navbar,\n   then light sections. */\n\n.svc-page {\n  width: 100%;\n}\n\n/* Hero */\n.svc-hero {\n  position: relative;\n  margin-top: calc(-1 * var(--nav-offset));\n  padding: calc(var(--nav-offset) + 56px) 16px 88px;\n  color: #ffffff;\n  background:\n    radial-gradient(700px 360px at 10% 0%, rgba(0, 82, 204, 0.55), transparent 70%),\n    radial-gradient(640px 360px at 95% 60%, rgba(0, 163, 255, 0.3), transparent 70%),\n    #0f1b3d;\n  overflow: hidden;\n}\n\n.svc-hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n  background-size: 48px 48px;\n  -webkit-mask-image: radial-gradient(ellipse at 30% 40%, #000 15%, transparent 70%);\n  mask-image: radial-gradient(ellipse at 30% 40%, #000 15%, transparent 70%);\n  pointer-events: none;\n}\n\n.svc-hero-inner {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.svc-hero-empty .svc-hero-inner {\n  grid-template-columns: minmax(0, 1fr);\n  text-align: center;\n}\n\n.svc-hero-empty .svc-hero-actions {\n  justify-content: center;\n}\n\n.svc-hero-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.svc-hero-empty .svc-hero-text {\n  align-items: center;\n}\n\n.svc-hero-kicker {\n  padding: 5px 14px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n  background: rgba(125, 211, 252, 0.12);\n  border: 1px solid rgba(125, 211, 252, 0.25);\n}\n\n.svc-hero-title {\n  margin: 18px 0 10px;\n  font-size: clamp(34px, 4.2vw, 54px);\n  line-height: 1.08;\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  color: #ffffff;\n}\n\n.svc-hero-tagline {\n  margin: 0 0 18px;\n  font-size: 19px;\n  font-weight: 600;\n  color: #7dd3fc;\n}\n\n.svc-hero-desc {\n  margin: 0;\n  max-width: 560px;\n  font-size: 16.5px;\n  line-height: 1.7;\n  color: rgba(226, 232, 240, 0.82);\n}\n\n.svc-hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.svc-hero-media {\n  position: relative;\n}\n\n/* Soft glow behind the photo so it sits in the navy rather than on it. */\n.svc-hero-media::before {\n  content: \"\";\n  position: absolute;\n  inset: 8% -4% -6% 6%;\n  border-radius: 28px;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  opacity: 0.35;\n  filter: blur(40px);\n}\n\n.svc-hero-media img {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.35);\n}\n\n/* Buttons */\n.pill-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 50px;\n  padding: 13px 24px;\n  border-radius: 999px;\n  font-size: 15px;\n  font-weight: 700;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.pill-btn svg {\n  transition: transform 0.2s ease;\n}\n\n.pill-btn:hover {\n  transform: translateY(-2px);\n}\n\n.pill-btn:hover svg {\n  transform: translateX(3px);\n}\n\n.pill-btn-primary {\n  color: #ffffff;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  box-shadow: 0 14px 32px rgba(0, 163, 255, 0.3);\n}\n\n.pill-btn-primary:hover {\n  box-shadow: 0 18px 40px rgba(0, 163, 255, 0.4);\n}\n\n.pill-btn-ghost {\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.pill-btn-ghost:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.pill-btn-light {\n  color: #0f1b3d;\n  background: #ffffff;\n}\n\n.pill-btn-light:hover {\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);\n}\n\n.pill-btn:focus-visible,\n.svc-related-card:focus-visible,\n.cta-band-phone:focus-visible {\n  outline: 2px solid #7dd3fc;\n  outline-offset: 3px;\n}\n\n/* Light sections */\n.svc-section {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 72px 16px 0;\n}\n\n.svc-section-head {\n  margin-bottom: 28px;\n}\n\n.svc-section-kicker {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--secondary);\n}\n\n.svc-section-title {\n  margin: 0;\n  font-size: clamp(26px, 2.6vw, 34px);\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n/* What's included */\n.svc-points {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.svc-point {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 22px 24px;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);\n  font-size: 16px;\n  line-height: 1.55;\n  color: var(--text-main);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.svc-point:hover {\n  border-color: rgba(0, 82, 204, 0.2);\n  box-shadow: 0 14px 30px rgba(15, 35, 95, 0.08);\n}\n\n.svc-point-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 40px;\n  height: 40px;\n  border-radius: 12px;\n  color: var(--primary);\n  background: var(--primary-light);\n}\n\n/* Related services */\n/* Compact image-beside-text cards; auto-fit stretches them across the row\n   whether a category has two siblings or five. */\n.svc-related {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 16px;\n}\n\n.svc-related-card {\n  display: flex;\n  border-radius: 20px;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.svc-related-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px rgba(15, 35, 95, 0.12);\n}\n\n.svc-related-image {\n  display: block;\n  flex: 0 0 38%;\n  min-height: 150px;\n  overflow: hidden;\n  background: var(--primary-light);\n}\n\n.svc-related-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.svc-related-card:hover .svc-related-image img {\n  transform: scale(1.04);\n}\n\n.svc-related-body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 18px 20px;\n}\n\n.svc-related-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.svc-related-tagline {\n  margin: 4px 0 14px;\n  font-size: 14.5px;\n  line-height: 1.5;\n  color: var(--text-muted);\n}\n\n.svc-related-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: auto;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.svc-related-more svg {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n}\n\n.svc-related-card:hover .svc-related-more svg {\n  transform: translateX(3px);\n}\n\n/* Closing band */\n.cta-band-section {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 72px 16px 80px;\n}\n\n.cta-band {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 24px 40px;\n  padding: 40px 44px;\n  border-radius: 28px;\n  color: #ffffff;\n  background:\n    radial-gradient(500px 240px at 100% 0%, rgba(0, 163, 255, 0.35), transparent 70%),\n    radial-gradient(420px 260px at 0% 100%, rgba(0, 82, 204, 0.5), transparent 70%),\n    #0f1b3d;\n  box-shadow: 0 24px 50px rgba(15, 27, 61, 0.22);\n}\n\n.cta-band-text h2 {\n  margin: 0 0 6px;\n  font-size: clamp(24px, 2.4vw, 30px);\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.cta-band-text p {\n  margin: 0;\n  font-size: 16px;\n  color: rgba(226, 232, 240, 0.8);\n}\n\n.cta-band-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 20px;\n}\n\n.cta-band-phone {\n  font-size: 15px;\n  font-weight: 600;\n  color: #7dd3fc;\n}\n\n.cta-band-phone:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 900px) {\n  .svc-hero {\n    padding: calc(var(--nav-offset) + 32px) 16px 56px;\n  }\n\n  .svc-hero-inner {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 36px;\n  }\n\n  .svc-hero-tagline {\n    font-size: 17px;\n  }\n\n  .svc-hero-desc {\n    font-size: 15.5px;\n  }\n\n  .svc-section {\n    padding-top: 52px;\n  }\n\n  .svc-points {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .svc-point {\n    padding: 18px;\n    font-size: 15px;\n  }\n\n  .cta-band-section {\n    padding-top: 52px;\n    padding-bottom: 56px;\n  }\n\n  .cta-band {\n    padding: 30px 22px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pill-btn,\n  .pill-btn svg,\n  .svc-related-card,\n  .svc-related-image img,\n  .svc-related-more svg {\n    transition: none;\n  }\n}\n\n/* ===========================\n   NAVBAR\n   Floating pill header, services mega menu, mobile sheet.\n   Everything nav-related lives in this one block.\n   =========================== */\n\n:root {\n  /* How far page content sits below the floating bar. */\n  --nav-offset: 88px;\n}\n\n.site-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 14px max(var(--gutter), calc((100% - var(--container)) / 2));\n  transition: padding 0.25s ease;\n}\n\n.site-header.is-scrolled {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n/* Without this, page content shows in the strip above the floating pill as it\n   scrolls past. A masked blur fades it out and stays colour-neutral, so it\n   works over the dark hero and over light sections alike. */\n.site-header::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 -16px;\n  pointer-events: none;\n  opacity: 0;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  -webkit-mask-image: linear-gradient(to bottom, #000 58%, transparent);\n  mask-image: linear-gradient(to bottom, #000 58%, transparent);\n  transition: opacity 0.25s ease;\n}\n\n.site-header.is-scrolled::before {\n  opacity: 1;\n}\n\n/* The bar itself - a pill that floats clear of the viewport edge. */\n.navbar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  height: 60px;\n  padding: 0 10px 0 20px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.82);\n  -webkit-backdrop-filter: blur(18px) saturate(160%);\n  backdrop-filter: blur(18px) saturate(160%);\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1);\n  transition: height 0.25s ease, background 0.25s ease, box-shadow 0.25s ease,\n    border-color 0.25s ease;\n}\n\n.site-header.is-scrolled .navbar {\n  height: 54px;\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(15, 23, 42, 0.07);\n  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.16);\n}\n\n/* An open menu needs an opaque bar, otherwise the panel shows through it. */\n.site-header.is-menu-open .navbar {\n  background: #ffffff;\n  border-color: rgba(15, 23, 42, 0.07);\n  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.16);\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.nav-logo img {\n  height: 38px;\n  display: block;\n  transition: height 0.25s ease;\n}\n\n.site-header.is-scrolled .nav-logo img {\n  height: 34px;\n}\n\n/* ---- Desktop links ---- */\n\n.nav-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.nav-links {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.nav-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 9px 14px;\n  border-radius: 999px;\n  font-size: 15px;\n  font-weight: 500;\n  font-family: inherit;\n  line-height: 1;\n  color: #334155;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: color 0.18s ease, background 0.18s ease;\n}\n\n.nav-link:hover,\n.nav-item.is-open > .nav-link {\n  color: #1d4ed8;\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.nav-links a.nav-link.active {\n  color: #1d4ed8;\n  font-weight: 600;\n  background: rgba(37, 99, 235, 0.1);\n}\n\n.nav-caret {\n  width: 12px;\n  height: 12px;\n  transition: transform 0.2s ease;\n}\n\n.nav-item.is-open .nav-caret {\n  transform: rotate(180deg);\n}\n\n/* ---- Right side ---- */\n\n.nav-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.nav-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 11px 20px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  text-decoration: none;\n  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n}\n\n.nav-cta svg {\n  width: 14px;\n  height: 14px;\n  transition: transform 0.18s ease;\n}\n\n.nav-cta:hover {\n  filter: brightness(1.06);\n  transform: translateY(-1px);\n  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.38);\n}\n\n.nav-cta:hover svg {\n  transform: translateX(3px);\n}\n\n/* ---- Hamburger ---- */\n\n.nav-toggle {\n  position: relative;\n  display: none;\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: #ffffff;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.nav-toggle span {\n  position: absolute;\n  left: 12px;\n  width: 18px;\n  height: 2px;\n  border-radius: 2px;\n  background: #0f172a;\n  transition: transform 0.25s ease, opacity 0.18s ease;\n}\n\n.nav-toggle span:nth-child(1) {\n  top: 15px;\n}\n\n.nav-toggle span:nth-child(2) {\n  top: 20px;\n}\n\n.nav-toggle span:nth-child(3) {\n  top: 25px;\n}\n\n.nav-toggle.is-open span:nth-child(1) {\n  transform: translateY(5px) rotate(45deg);\n}\n\n.nav-toggle.is-open span:nth-child(2) {\n  opacity: 0;\n}\n\n.nav-toggle.is-open span:nth-child(3) {\n  transform: translateY(-5px) rotate(-45deg);\n}\n\n/* ---- Services mega menu (desktop) ---- */\n\n/* The panel lives inside the Services item so keyboard order runs\n   trigger -> links, but it is positioned against the bar so it can span it. */\n.nav-item.services-nav {\n  position: static;\n}\n\n.mega-menu {\n  position: absolute;\n  top: calc(100% + 14px);\n  left: 0;\n  right: 0;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s;\n}\n\n.mega-menu.is-open {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.mega-menu-inner {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr)) 268px;\n  gap: 28px;\n  padding: 24px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  border-radius: 22px;\n  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.18);\n}\n\n.mega-column {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.mega-heading {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n  padding: 0 10px;\n  margin-bottom: 8px;\n}\n\n.mega-link {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 9px 10px;\n  border-radius: 12px;\n  text-decoration: none;\n  transition: background 0.16s ease;\n}\n\n.mega-link:hover {\n  background: #f1f5f9;\n}\n\n.mega-link-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.mega-link-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.mega-link-blurb {\n  font-size: 12px;\n  line-height: 1.4;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n/* The one promoted action in the menu, for people who cannot place themselves\n   in any of the three columns. */\n.mega-feature {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 22px;\n  border-radius: 18px;\n  background: linear-gradient(160deg, #0f172a, #1e3a8a);\n  color: #ffffff;\n}\n\n.mega-feature-eyebrow {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #93c5fd;\n}\n\n.mega-feature-copy {\n  font-size: 13px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.82);\n  margin: 10px 0 16px;\n}\n\n.mega-feature-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 18px;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.mega-feature-cta svg {\n  width: 14px;\n  height: 14px;\n  transition: transform 0.18s ease;\n}\n\n.mega-feature-cta:hover svg {\n  transform: translateX(3px);\n}\n\n.mega-feature-link {\n  margin-top: 12px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.mega-feature-link:hover {\n  color: #ffffff;\n}\n\n/* ---- About menu (desktop) ----\n   Same panel as Services, just narrower: two link columns plus the feature\n   card. Positioned against the bar like Services, and centred on it. */\n.nav-item.about-nav {\n  position: static;\n}\n\n.about-mega-menu {\n  left: 50%;\n  right: auto;\n  width: min(760px, 100%);\n  transform: translate(-50%, -10px);\n}\n\n.about-mega-menu.is-open {\n  transform: translate(-50%, 0);\n}\n\n.about-mega-inner {\n  grid-template-columns: repeat(2, minmax(0, 1fr)) 248px;\n}\n\n/* Show which About page you are on */\n.about-mega-menu .mega-link.active {\n  background: #eff6ff;\n}\n\n/* ---- Mobile sheet: hidden until the mobile breakpoint ---- */\n\n.mobile-menu {\n  display: none;\n}\n\n/* ---- Focus states ---- */\n\n.site-header a:focus-visible,\n.site-header button:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n/* ---- Breakpoint: tablet and below ---- */\n\n@media (max-width: 900px) {\n  :root {\n    --nav-offset: 74px;\n  }\n\n  .site-header {\n    padding: 10px var(--gutter);\n  }\n\n  .site-header.is-scrolled {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  .navbar {\n    height: 54px;\n    padding: 0 8px 0 16px;\n    gap: 12px;\n  }\n\n  .site-header.is-scrolled .navbar {\n    height: 52px;\n  }\n\n  .nav-logo img,\n  .site-header.is-scrolled .nav-logo img {\n    height: 32px;\n  }\n\n  .nav-center,\n  .mega-menu {\n    display: none;\n  }\n\n  .nav-right {\n    margin-left: auto;\n  }\n\n  .nav-toggle {\n    display: block;\n  }\n\n  .nav-cta {\n    padding: 9px 16px;\n    font-size: 13px;\n    box-shadow: none;\n  }\n\n  .nav-cta svg {\n    display: none;\n  }\n\n  .mobile-menu {\n    display: block;\n    position: fixed;\n    top: var(--nav-offset);\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #ffffff;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-12px);\n    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .mobile-menu.is-open {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n\n  .mobile-menu-inner {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    padding: 12px var(--gutter) 32px;\n  }\n\n  .mobile-menu-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    flex: 1;\n  }\n\n  .mobile-link,\n  .mobile-group-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 14px 4px;\n    border: none;\n    border-bottom: 1px solid #eef2f7;\n    background: none;\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 500;\n    color: #0f172a;\n    text-decoration: none;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  .mobile-link.active {\n    color: #1d4ed8;\n  }\n\n  .mobile-caret {\n    width: 14px;\n    height: 14px;\n    color: #94a3b8;\n    transition: transform 0.2s ease;\n  }\n\n  .mobile-caret.is-open {\n    transform: rotate(180deg);\n  }\n\n  .mobile-panel {\n    padding: 6px 0 12px;\n  }\n\n  .mobile-panel-group + .mobile-panel-group {\n    margin-top: 12px;\n  }\n\n  .mobile-panel-title {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.16em;\n    color: #94a3b8;\n    padding: 6px 4px;\n  }\n\n  .mobile-sub-link {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 4px;\n    font-size: 15px;\n    color: #334155;\n    text-decoration: none;\n  }\n\n  .mobile-sub-link.active {\n    color: #1d4ed8;\n    font-weight: 600;\n  }\n\n  .mobile-menu-footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding-top: 24px;\n  }\n\n  .mobile-cta {\n    display: block;\n    width: 100%;\n    padding: 14px;\n    border-radius: 999px;\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: #ffffff;\n    font-size: 15px;\n    font-weight: 600;\n    text-align: center;\n    text-decoration: none;\n  }\n\n  .mobile-call {\n    font-size: 14px;\n    color: #64748b;\n  }\n}\n\n/* The CTA and the burger crowd each other on small phones. The sheet carries\n   the same action, so drop the one in the bar. */\n@media (max-width: 420px) {\n  .nav-cta {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .site-header,\n  .site-header *,\n  .mobile-menu,\n  .mobile-menu * {\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* ===========================\n   FAQ SECTION\n   =========================== */\n\n.faq-section {\n  padding-top: 72px;\n  padding-bottom: 72px;\n}\n\n.faq-grid {\n  max-width: var(--container);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.4fr);\n  gap: 40px;\n  align-items: start;\n}\n\n/* Intro panel: dark, like the hero, so the section has an anchor. Sticky so it\n   stays alongside the list while someone reads down the answers. */\n.faq-intro {\n  position: sticky;\n  top: calc(var(--nav-offset) + 16px);\n  display: flex;\n  flex-direction: column;\n  padding: 36px 32px 32px;\n  border-radius: 24px;\n  color: #e2e8f0;\n  background:\n    radial-gradient(420px 220px at 100% 0%, rgba(0, 163, 255, 0.35), transparent 70%),\n    radial-gradient(360px 260px at 0% 100%, rgba(0, 82, 204, 0.45), transparent 70%),\n    #0f1b3d;\n  box-shadow: 0 24px 50px rgba(15, 27, 61, 0.25);\n  overflow: hidden;\n}\n\n.faq-kicker {\n  align-self: flex-start;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  color: #7dd3fc;\n  background: rgba(125, 211, 252, 0.12);\n  border: 1px solid rgba(125, 211, 252, 0.25);\n}\n\n.faq-title {\n  margin: 18px 0 12px;\n  font-size: clamp(28px, 2.8vw, 36px);\n  line-height: 1.15;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.faq-lead {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.65;\n  color: rgba(226, 232, 240, 0.8);\n}\n\n.faq-cta {\n  margin-top: 32px;\n  padding: 20px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.faq-cta-title {\n  margin: 0 0 4px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.faq-cta-text {\n  margin: 0 0 16px;\n  font-size: 14px;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.faq-cta-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 16px;\n}\n\n.faq-cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 20px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  box-shadow: 0 12px 28px rgba(0, 163, 255, 0.3);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.faq-cta-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 34px rgba(0, 163, 255, 0.4);\n}\n\n.faq-cta-phone {\n  font-size: 14px;\n  font-weight: 600;\n  color: #7dd3fc;\n}\n\n.faq-cta-phone:hover {\n  text-decoration: underline;\n}\n\n/* Question list */\n.faq-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faq-item {\n  background: #ffffff;\n  border-radius: 18px;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.faq-item:hover {\n  border-color: rgba(0, 82, 204, 0.2);\n}\n\n.faq-item.open {\n  border-color: rgba(0, 82, 204, 0.25);\n  box-shadow: 0 18px 40px rgba(15, 35, 95, 0.1);\n}\n\n.faq-item-heading {\n  margin: 0;\n  font: inherit;\n}\n\n.faq-question {\n  width: 100%;\n  padding: 20px 22px;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  color: var(--text-main);\n  border-radius: 18px;\n}\n\n.faq-question:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.faq-number {\n  flex: 0 0 auto;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  color: rgba(0, 82, 204, 0.45);\n  font-variant-numeric: tabular-nums;\n  transition: color 0.25s ease;\n}\n\n.faq-item.open .faq-number {\n  color: var(--primary);\n}\n\n.faq-question-text {\n  flex: 1;\n  font-size: 17px;\n  font-weight: 650;\n  line-height: 1.4;\n}\n\n/* Plus that turns into a minus: two bars, the vertical one rotates flat. */\n.faq-toggle {\n  position: relative;\n  flex: 0 0 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--primary-light);\n  transition: background-color 0.25s ease, transform 0.3s ease;\n}\n\n.faq-toggle::before,\n.faq-toggle::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 12px;\n  height: 2px;\n  margin: -1px 0 0 -6px;\n  border-radius: 2px;\n  background: var(--primary);\n  transition: transform 0.3s ease, background-color 0.25s ease;\n}\n\n.faq-toggle::after {\n  transform: rotate(90deg);\n}\n\n.faq-question:hover .faq-toggle {\n  background: #d5e5ff;\n}\n\n.faq-item.open .faq-toggle {\n  background: var(--primary);\n  transform: rotate(180deg);\n}\n\n.faq-item.open .faq-toggle::before,\n.faq-item.open .faq-toggle::after {\n  background: #ffffff;\n}\n\n.faq-item.open .faq-toggle::after {\n  transform: rotate(0deg);\n}\n\n/* Grid-row trick animates to the answer's real height, so long answers are\n   never cut off the way a fixed max-height would. */\n.faq-answer-wrapper {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s ease;\n}\n\n.faq-item.open .faq-answer-wrapper {\n  grid-template-rows: 1fr;\n}\n\n.faq-answer-inner {\n  overflow: hidden;\n}\n\n.faq-answer {\n  margin: 0;\n  padding: 0 22px 22px 61px;\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n@media (max-width: 900px) {\n  .faq-section {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n\n  .faq-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 24px;\n  }\n\n  .faq-intro {\n    position: static;\n    padding: 28px 22px 24px;\n  }\n\n  .faq-question {\n    padding: 18px 16px;\n    gap: 12px;\n  }\n\n  .faq-question-text {\n    font-size: 15.5px;\n  }\n\n  .faq-answer {\n    padding: 0 16px 18px 16px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .faq-answer-wrapper,\n  .faq-toggle,\n  .faq-toggle::before,\n  .faq-toggle::after {\n    transition: none;\n  }\n}\n\n/* ===========================\n   RESPONSIVE TWEAKS FOR LOOPS\n   =========================== */\n\n@media (max-width: 900px) {\n  .loan-services-section,\n  .protection-services-section,\n  .business-services-section {\n    width: 100%;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* Mobile layout for service carousels */\n\n@media (max-width: 640px) {\n  .loan-loop-card,\n  .protection-loop-card,\n  .business-loop-card {\n    flex: 0 0 90vw;\n    flex-direction: column;\n  }\n\n  .loan-card-image,\n  .protection-card-image,\n  .business-card-image {\n    flex: 0 0 auto;\n  }\n\n  .loan-card-image img,\n  .protection-card-image img,\n  .business-card-image img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n  }\n\n  .loan-card-content,\n  .protection-card-content,\n  .business-card-content {\n    padding: 14px 14px;\n  }\n}\n\n/* ===========================\n   SERVICE CAROUSELS (Loans / Protection / Business)\n   ===========================\n   The rows sit still; visitors step through them with the arrow buttons,\n   keyboard arrows, or a swipe. The rows use a wider column than the rest of\n   the page (they are image-heavy and read fine wide), and bleed off the right\n   edge so it is obvious there is more. */\n\n.svc-carousel {\n  --edge: max(var(--gutter), calc((100% - 1760px) / 2));\n  margin-top: 6px;\n}\n\n.svc-carousel-track {\n  display: flex;\n  gap: 24px;\n  overflow-x: auto;\n  overscroll-behavior-x: contain;\n  scroll-snap-type: x mandatory;\n  scroll-padding-inline: var(--edge);\n  /* Room above for the hover lift and below for the card shadow, both of\n     which an overflow container would otherwise clip. */\n  padding: 14px var(--edge) 34px;\n  scrollbar-width: none;\n}\n\n.svc-carousel-track::-webkit-scrollbar {\n  display: none;\n}\n\n.svc-carousel-track:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: -2px;\n  border-radius: 12px;\n}\n\n.svc-carousel .svc-carousel-track > * {\n  flex: 0 0 640px;\n  flex-direction: row;\n  min-height: 300px;\n  scroll-snap-align: start;\n}\n\n/* Every image fills its half of the card, whatever its original shape, so\n   the row reads as one even strip. */\n.svc-carousel .loan-card-image,\n.svc-carousel .protection-card-image,\n.svc-carousel .business-card-image {\n  position: relative;\n  flex: 0 0 46%;\n  background: var(--primary-light);\n}\n\n.svc-carousel .loan-card-image img,\n.svc-carousel .protection-card-image img,\n.svc-carousel .business-card-image img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.svc-carousel .loan-card-content,\n.svc-carousel .protection-card-content,\n.svc-carousel .business-card-content {\n  padding: 24px 24px 22px;\n}\n\n/* Tag stays pinned to the top and the link to the bottom; the title and\n   description sit centred in the space between, rather than leaving a hole\n   above the link on cards with short copy. */\n.svc-carousel .loan-card-title,\n.svc-carousel .protection-card-title,\n.svc-carousel .business-card-title {\n  margin-top: auto;\n}\n\n/* Larger type than the base card styles: these cards are wide enough to carry\n   it, and it fills the card instead of floating in white space. */\n.svc-carousel .loan-card-tag,\n.svc-carousel .protection-card-tag,\n.svc-carousel .business-card-tag {\n  font-size: 13px;\n}\n\n.svc-carousel .loan-card-title,\n.svc-carousel .protection-card-title,\n.svc-carousel .business-card-title {\n  font-size: 25px;\n  line-height: 1.2;\n}\n\n.svc-carousel .loan-card-description,\n.svc-carousel .protection-card-description,\n.svc-carousel .business-card-description {\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.svc-carousel .loan-card-link,\n.svc-carousel .protection-card-link,\n.svc-carousel .business-card-link {\n  font-size: 15px;\n}\n\n@media (max-width: 900px) {\n  .svc-carousel .loan-card-title,\n  .svc-carousel .protection-card-title,\n  .svc-carousel .business-card-title {\n    font-size: 21px;\n  }\n\n  .svc-carousel .loan-card-description,\n  .svc-carousel .protection-card-description,\n  .svc-carousel .business-card-description {\n    font-size: 15px;\n  }\n}\n\n.svc-carousel-controls {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 0 var(--edge);\n}\n\n/* Page dots: one per stop. The current one stretches into a pill, so where\n   you are reads at a glance instead of from the length of a thin line. */\n.svc-carousel-dots {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: 8px;\n}\n\n.svc-carousel-dot {\n  width: 10px;\n  height: 10px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: rgba(0, 82, 204, 0.18);\n  cursor: pointer;\n  transition: width 0.35s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.25s ease;\n}\n\n.svc-carousel-dot:hover {\n  background: rgba(0, 82, 204, 0.4);\n}\n\n.svc-carousel-dot.active {\n  width: 34px;\n  background: linear-gradient(90deg, var(--primary), var(--secondary));\n}\n\n.svc-carousel-dot:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 3px;\n}\n\n.svc-carousel-count {\n  margin-left: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.svc-carousel-count strong {\n  color: var(--text-main);\n}\n\n.svc-carousel-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.svc-carousel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid rgba(15, 35, 95, 0.12);\n  background: var(--white);\n  color: var(--primary);\n  box-shadow: 0 6px 16px rgba(15, 35, 95, 0.08);\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease,\n    border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.svc-carousel-btn:hover:not(:disabled) {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: var(--white);\n  box-shadow: 0 10px 22px rgba(0, 82, 204, 0.28);\n  transform: translateY(-2px);\n}\n\n.svc-carousel-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.svc-carousel-btn:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 3px;\n}\n\n.svc-carousel-btn:disabled {\n  color: rgba(15, 35, 95, 0.28);\n  box-shadow: none;\n  cursor: default;\n}\n\n@media (max-width: 900px) {\n  /* The sections pick up 16px side padding here; let the row bleed past it\n     to the screen edge instead of being clipped short. */\n  .svc-carousel {\n    --edge: 16px;\n    margin-left: -16px;\n    margin-right: -16px;\n  }\n\n  .svc-carousel-track {\n    gap: 16px;\n  }\n\n  .svc-carousel .svc-carousel-track > * {\n    flex: 0 0 min(400px, 82vw);\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .svc-carousel .loan-card-image,\n  .svc-carousel .protection-card-image,\n  .svc-carousel .business-card-image {\n    flex: 0 0 200px;\n  }\n\n  .svc-carousel .loan-card-content,\n  .svc-carousel .protection-card-content,\n  .svc-carousel .business-card-content {\n    padding: 18px;\n  }\n\n  .svc-carousel-btn {\n    width: 42px;\n    height: 42px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .svc-carousel-dot,\n  .svc-carousel-btn {\n    transition: none;\n  }\n}\n\n/* =========================\n   CONTACT PAGE\n   =========================\n   Navy header that runs up behind the floating navbar (as the home hero does),\n   with the form and details cards overlapping its bottom edge. */\n\n.contact-page {\n  width: 100%;\n}\n\n/* Hero */\n.contact-hero {\n  position: relative;\n  width: 100%;\n  margin-top: calc(-1 * var(--nav-offset));\n  padding: calc(var(--nav-offset) + 64px) 16px 150px;\n  color: #ffffff;\n  background:\n    radial-gradient(700px 320px at 15% 0%, rgba(0, 82, 204, 0.55), transparent 70%),\n    radial-gradient(600px 300px at 90% 30%, rgba(0, 163, 255, 0.35), transparent 70%),\n    #0f1b3d;\n  overflow: hidden;\n}\n\n/* Faint grid texture so the navy doesn't read as a flat block. */\n.contact-hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n  background-size: 48px 48px;\n  -webkit-mask-image: radial-gradient(ellipse at center, #000 20%, transparent 75%);\n  mask-image: radial-gradient(ellipse at center, #000 20%, transparent 75%);\n  pointer-events: none;\n}\n\n.contact-hero-inner {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n  text-align: center;\n}\n\n.contact-kicker {\n  display: inline-block;\n  padding: 5px 14px;\n  border-radius: 999px;\n  font-size: 11px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #7dd3fc;\n  background: rgba(125, 211, 252, 0.12);\n  border: 1px solid rgba(125, 211, 252, 0.25);\n  margin-bottom: 18px;\n}\n\n.contact-title {\n  margin: 0 0 14px;\n  font-size: clamp(32px, 4vw, 52px);\n  line-height: 1.1;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: #ffffff;\n}\n\n.contact-subtitle {\n  margin: 0 auto;\n  max-width: 620px;\n  font-size: 17px;\n  text-wrap: balance;\n  line-height: 1.6;\n  color: rgba(226, 232, 240, 0.8);\n}\n\n/* Layout */\n.contact-wrap {\n  position: relative;\n  width: 100%;\n  margin-top: -100px;\n  padding: 0 16px 80px;\n}\n\n.contact-grid {\n  max-width: var(--container);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);\n  gap: 24px;\n  align-items: stretch;\n}\n\n/* Cards */\n.contact-card {\n  background: #ffffff;\n  border-radius: 24px;\n  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);\n  border: 1px solid rgba(15, 35, 95, 0.06);\n}\n\n.contact-card-form {\n  padding: 36px 36px 32px;\n}\n\n.contact-card-header {\n  margin-bottom: 26px;\n}\n\n.contact-card-header h2 {\n  margin: 0 0 6px;\n  font-size: 24px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.contact-card-header p {\n  margin: 0;\n  font-size: 15px;\n  color: var(--text-muted);\n}\n\n/* Alerts */\n.contact-alert {\n  margin: 0 0 20px;\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 14px;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n.contact-alert.success {\n  background: rgba(34, 197, 94, 0.08);\n  border-color: rgba(34, 197, 94, 0.25);\n  color: #166534;\n}\n.contact-alert.error {\n  background: rgba(239, 68, 68, 0.08);\n  border-color: rgba(239, 68, 68, 0.25);\n  color: #991b1b;\n}\n\n/* Form */\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.contact-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.contact-field label,\n.contact-field legend {\n  display: block;\n  padding: 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #0f172a;\n}\n\n.contact-field input:not([type=\"radio\"]),\n.contact-field select,\n.contact-field textarea {\n  width: 100%;\n  min-height: 50px;\n  border-radius: 14px;\n  border: 1.5px solid #e2e8f0;\n  padding: 12px 16px;\n  font-size: 15px;\n  color: var(--text-main);\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n  font-family: inherit;\n  background: #f8fafc;\n}\n\n.contact-field input::placeholder,\n.contact-field textarea::placeholder {\n  color: #94a3b8;\n}\n\n.contact-field select {\n  appearance: none;\n  padding-right: 44px;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' fill='none' stroke='%230052cc' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 18px center;\n}\n\n.contact-field textarea {\n  min-height: 140px;\n  resize: vertical;\n  line-height: 1.55;\n}\n\n.contact-field input:not([type=\"radio\"]):hover,\n.contact-field select:hover,\n.contact-field textarea:hover {\n  border-color: #cbd5e1;\n}\n\n.contact-field input:not([type=\"radio\"]):focus,\n.contact-field select:focus,\n.contact-field textarea:focus {\n  border-color: var(--primary);\n  background-color: #ffffff;\n  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.1);\n}\n\n.contact-field input.invalid,\n.contact-field textarea.invalid {\n  border-color: rgba(239, 68, 68, 0.65);\n  background-color: #fff;\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);\n}\n\n.contact-error {\n  margin-top: 6px;\n  font-size: 12.5px;\n  color: #dc2626;\n}\n\n/* Contact method toggle */\n.contact-method {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n}\n\n.contact-segment {\n  display: inline-flex;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 14px;\n  background: #eef2f7;\n}\n\n.contact-segment-option {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 10px 22px;\n  border-radius: 11px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n/* Out-specify the generic \".contact-field label\" rule above. */\n.contact-field .contact-segment-option {\n  display: inline-flex;\n  margin-bottom: 0;\n  padding: 10px 22px;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.contact-segment-option svg {\n  width: 17px;\n  height: 17px;\n}\n\n.contact-segment-option input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.contact-field .contact-segment-option.active {\n  background: #ffffff;\n  color: var(--primary);\n  box-shadow: 0 4px 12px rgba(15, 35, 95, 0.1);\n}\n\n.contact-segment-option:has(input:focus-visible) {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n/* Consent checkbox */\n.contact-check {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  font-size: 14px;\n  color: #334155;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.contact-check input {\n  position: absolute;\n  opacity: 0;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n}\n\n.contact-check-box {\n  flex: 0 0 20px;\n  height: 20px;\n  margin-top: 1px;\n  border-radius: 6px;\n  border: 1.5px solid #cbd5e1;\n  background: #ffffff;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.contact-check input:checked + .contact-check-box {\n  border-color: var(--primary);\n  background: var(--primary)\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 10'%3E%3Cpath d='M1 5l3.5 3.5L11 1.5' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")\n    center / 12px no-repeat;\n}\n\n.contact-check input:focus-visible + .contact-check-box {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.contact-check.invalid .contact-check-box {\n  border-color: rgba(239, 68, 68, 0.75);\n}\n\n.contact-check.invalid span {\n  color: #dc2626;\n}\n\n/* Submit */\n.contact-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 54px;\n  border: none;\n  border-radius: 999px;\n  padding: 14px 24px;\n  font-weight: 700;\n  font-size: 15.5px;\n  font-family: inherit;\n  color: #fff;\n  cursor: pointer;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  box-shadow: 0 14px 32px rgba(0, 82, 204, 0.3);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n\n.contact-submit svg {\n  transition: transform 0.2s ease;\n}\n\n.contact-submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 18px 40px rgba(0, 82, 204, 0.38);\n}\n\n.contact-submit:hover:not(:disabled) svg {\n  transform: translateX(3px);\n}\n\n.contact-submit:disabled {\n  opacity: 0.7;\n  cursor: progress;\n}\n\n.contact-reassure {\n  margin: -6px 0 0;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* Side column */\n.contact-side {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.contact-card-info {\n  padding: 32px 28px 28px;\n  color: #e2e8f0;\n  border: none;\n  background:\n    radial-gradient(380px 220px at 100% 0%, rgba(0, 163, 255, 0.3), transparent 70%),\n    linear-gradient(160deg, #13235a, #0f1b3d);\n}\n\n.contact-info-eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.contact-card-info h2 {\n  margin: 0 0 24px;\n  font-size: 22px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.contact-info-block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 24px;\n}\n\n.contact-info-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 10px;\n  margin: 0 -10px;\n  border-radius: 14px;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #ffffff;\n  text-decoration: none;\n  transition: background-color 0.2s ease;\n}\n\na.contact-info-line:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.contact-ico {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 42px;\n  height: 42px;\n  border-radius: 12px;\n  color: #7dd3fc;\n  background: rgba(125, 211, 252, 0.12);\n  border: 1px solid rgba(125, 211, 252, 0.18);\n}\n\n.contact-info-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-info-label {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba(226, 232, 240, 0.6);\n  margin-bottom: 1px;\n}\n\n.contact-map-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  border-radius: 999px;\n  padding: 13px 18px;\n  font-weight: 700;\n  font-size: 14.5px;\n  color: #0f1b3d;\n  background: #ffffff;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.contact-map-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);\n}\n\n/* Map card */\n.contact-card-map {\n  flex: 1;\n  min-height: 260px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.contact-map-frame {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 260px;\n}\n\n.contact-map-frame iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n\n/* Entrance animations */\n.contact-animate-left {\n  animation: contactRise 0.45s ease both;\n}\n.contact-animate-right {\n  animation: contactRise 0.45s ease both;\n  animation-delay: 0.08s;\n}\n@keyframes contactRise {\n  from { opacity: 0; transform: translateY(18px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .contact-animate-left,\n  .contact-animate-right {\n    animation: none;\n  }\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .contact-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .contact-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .contact-hero {\n    padding: calc(var(--nav-offset) + 40px) 16px 110px;\n  }\n  .contact-subtitle {\n    font-size: 15.5px;\n  }\n  .contact-wrap {\n    margin-top: -70px;\n    padding-bottom: 56px;\n  }\n  .contact-card-form {\n    padding: 26px 20px 24px;\n  }\n  .contact-card-info {\n    padding: 26px 20px 22px;\n  }\n  .contact-card-map,\n  .contact-map-frame {\n    min-height: 280px;\n  }\n}\n\n/* ===========================\n   PAGE HERO (shared)\n   ===========================\n   Navy header for the inner pages (Calculator, Our Team, About). Same look as\n   the Contact and service-page headers. */\n\n.page-hero {\n  position: relative;\n  margin-top: calc(-1 * var(--nav-offset));\n  padding: calc(var(--nav-offset) + 64px) 16px 88px;\n  color: #ffffff;\n  text-align: center;\n  background:\n    radial-gradient(700px 320px at 15% 0%, rgba(0, 82, 204, 0.55), transparent 70%),\n    radial-gradient(600px 300px at 90% 30%, rgba(0, 163, 255, 0.35), transparent 70%),\n    #0f1b3d;\n  overflow: hidden;\n}\n\n.page-hero-overlap {\n  padding-bottom: 150px;\n}\n\n.page-hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n  background-size: 48px 48px;\n  -webkit-mask-image: radial-gradient(ellipse at center, #000 20%, transparent 75%);\n  mask-image: radial-gradient(ellipse at center, #000 20%, transparent 75%);\n  pointer-events: none;\n}\n\n.page-hero-inner {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n}\n\n.page-hero-kicker {\n  display: inline-block;\n  padding: 5px 14px;\n  border-radius: 999px;\n  font-size: 11px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #7dd3fc;\n  background: rgba(125, 211, 252, 0.12);\n  border: 1px solid rgba(125, 211, 252, 0.25);\n  margin-bottom: 18px;\n}\n\n.page-hero-title {\n  margin: 0 0 14px;\n  font-size: clamp(32px, 4vw, 52px);\n  line-height: 1.1;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: #ffffff;\n}\n\n.page-hero-subtitle {\n  margin: 0 auto;\n  max-width: 620px;\n  font-size: 17px;\n  line-height: 1.6;\n  color: rgba(226, 232, 240, 0.8);\n  text-wrap: balance;\n}\n\n.pill-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n@media (max-width: 900px) {\n  .page-hero {\n    padding: calc(var(--nav-offset) + 40px) 16px 64px;\n  }\n\n  .page-hero-overlap {\n    padding-bottom: 110px;\n  }\n\n  .page-hero-subtitle {\n    font-size: 15.5px;\n  }\n}\n\n/* ===========================\n   CALCULATOR PAGE\n   =========================== */\n\n.calc-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 12px 16px;\n  margin-top: 28px;\n}\n\n.calc-toolbar .pill-btn {\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.calc-toolbar-note {\n  font-size: 14px;\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.calc-section {\n  position: relative;\n  max-width: var(--container);\n  margin: -100px auto 0;\n  padding: 0 16px;\n}\n\n.calc-grid {\n  display: grid;\n  gap: 20px;\n  align-items: start;\n}\n\n.calc-grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.calc-grid-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.calc-card {\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid rgba(15, 35, 95, 0.06);\n  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);\n  overflow: hidden;\n}\n\n.calc-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 22px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.calc-scenario-name {\n  min-width: 0;\n  flex: 1;\n  padding: 6px 10px;\n  margin-left: -10px;\n  border: 1.5px solid transparent;\n  border-radius: 10px;\n  background: transparent;\n  font-family: inherit;\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--text-main);\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.calc-scenario-name:hover {\n  background: #f8fafc;\n}\n\n.calc-scenario-name:focus {\n  outline: none;\n  border-color: var(--primary);\n  background: #ffffff;\n}\n\n.calc-card-tools {\n  display: flex;\n  gap: 8px;\n}\n\n.calc-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n}\n\n.calc-chip:hover:not(:disabled) {\n  border-color: var(--primary);\n  color: var(--primary);\n}\n\n.calc-chip.danger:hover:not(:disabled) {\n  border-color: #ef4444;\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n.calc-chip:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.calc-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n/* With a single scenario there is room for inputs and results side by side. */\n.calc-grid-1 .calc-form {\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n}\n\n.calc-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px 22px;\n}\n\n.calc-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px 14px;\n}\n\n.calc-field {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.calc-field-wide {\n  grid-column: 1 / -1;\n}\n\n.calc-field-label {\n  display: block;\n  padding: 0;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.calc-input-wrap {\n  display: flex;\n  align-items: center;\n  min-height: 48px;\n  border-radius: 14px;\n  border: 1.5px solid #e2e8f0;\n  background: #f8fafc;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.calc-input-wrap:hover {\n  border-color: #cbd5e1;\n}\n\n.calc-input-wrap:focus-within {\n  border-color: var(--primary);\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.1);\n}\n\n.calc-affix {\n  flex: 0 0 auto;\n  padding: 0 14px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.calc-affix:first-child {\n  padding-right: 0;\n}\n\n.calc-affix:last-child {\n  padding-left: 0;\n}\n\n.calc-input {\n  flex: 1;\n  min-width: 0;\n  height: 45px;\n  padding: 0 14px 0 8px;\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-main);\n  font-variant-numeric: tabular-nums;\n  outline: none;\n}\n\n.calc-input:first-child {\n  padding-left: 14px;\n}\n\n.calc-segment {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 14px;\n  background: #eef2f7;\n}\n\n.calc-segment-option {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  padding: 6px 10px;\n  border-radius: 10px;\n  font-size: 13.5px;\n  font-weight: 600;\n  text-align: center;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.calc-segment-option input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.calc-segment-option.active {\n  background: #ffffff;\n  color: var(--primary);\n  box-shadow: 0 4px 12px rgba(15, 35, 95, 0.1);\n}\n\n.calc-segment-option:has(input:focus-visible) {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.calc-submit {\n  width: 100%;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n/* Results */\n.calc-results {\n  padding: 24px 22px;\n  background: #f8fafc;\n  border-top: 1px solid #eef2f7;\n}\n\n.calc-grid-1 .calc-results {\n  border-top: none;\n  border-left: 1px solid #eef2f7;\n}\n\n.calc-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 100%;\n  min-height: 160px;\n  border-radius: 18px;\n  border: 1.5px dashed #d5deeb;\n  text-align: center;\n}\n\n.calc-empty-figure {\n  font-size: 30px;\n  font-weight: 800;\n  color: #cbd5e1;\n}\n\n.calc-empty p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.calc-headline {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 22px;\n  border-radius: 18px;\n  color: #ffffff;\n  background:\n    radial-gradient(300px 160px at 100% 0%, rgba(0, 163, 255, 0.4), transparent 70%),\n    #0f1b3d;\n}\n\n.calc-headline-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.calc-headline-value {\n  font-size: clamp(30px, 3.2vw, 40px);\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n}\n\n.calc-headline-note {\n  font-size: 13px;\n  color: #7dd3fc;\n}\n\n.calc-split {\n  margin: 18px 0;\n}\n\n.calc-split-bar {\n  display: flex;\n  height: 10px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #e2e8f0;\n}\n\n.calc-split-principal {\n  background: var(--primary);\n}\n\n.calc-split-interest {\n  background: #7dd3fc;\n}\n\n.calc-split-legend {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 4px 12px;\n  margin-top: 8px;\n  font-size: 12.5px;\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.calc-split-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.calc-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.calc-dot-principal {\n  background: var(--primary);\n}\n\n.calc-dot-interest {\n  background: #7dd3fc;\n}\n\n.calc-results-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.calc-stat {\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n}\n\n.calc-stat-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.calc-hint {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--primary);\n  background: var(--primary-light);\n  cursor: help;\n}\n\n.calc-stat-value {\n  margin-top: 4px;\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--text-main);\n  font-variant-numeric: tabular-nums;\n}\n\n.calc-preview {\n  margin-top: 16px;\n  border-radius: 14px;\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n}\n\n.calc-preview summary {\n  padding: 13px 16px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--primary);\n  cursor: pointer;\n}\n\n.calc-table-wrap {\n  overflow-x: auto;\n  padding: 0 8px 8px;\n}\n\n.calc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.calc-table th,\n.calc-table td {\n  padding: 8px;\n  text-align: right;\n}\n\n.calc-table th:first-child,\n.calc-table td:first-child {\n  text-align: left;\n}\n\n.calc-table th {\n  font-weight: 600;\n  color: var(--text-muted);\n  border-bottom: 1px solid #eef2f7;\n}\n\n.calc-table tbody tr:nth-child(even) {\n  background: #f8fafc;\n}\n\n.calc-table tr.final td {\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.calc-disclaimer {\n  margin: 18px 0 0;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n@media (max-width: 1100px) {\n  .calc-grid-3 {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .calc-section {\n    margin-top: -70px;\n  }\n\n  .calc-grid-2 {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .calc-grid-1 .calc-form {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .calc-grid-1 .calc-results {\n    border-left: none;\n    border-top: 1px solid #eef2f7;\n  }\n}\n\n@media (max-width: 520px) {\n  .calc-form-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .calc-inputs,\n  .calc-results {\n    padding: 20px 16px;\n  }\n}\n\n/* ===========================\n   OUR TEAM PAGE\n   =========================== */\n\n.team-section {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n.team-section-lead {\n  margin-top: -100px;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  align-items: stretch;\n}\n\n.team-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 24px;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.06);\n  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);\n}\n\n.team-card-photo {\n  position: relative;\n  aspect-ratio: 4 / 4.4;\n  background: var(--primary-light);\n  overflow: hidden;\n}\n\n.team-card-photo img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 20%;\n  transition: transform 0.5s ease;\n}\n\n.team-card:hover .team-card-photo img {\n  transform: scale(1.03);\n}\n\n.team-card-focus {\n  position: absolute;\n  left: 16px;\n  bottom: 16px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #0f1b3d;\n  background: rgba(255, 255, 255, 0.9);\n  -webkit-backdrop-filter: blur(6px);\n  backdrop-filter: blur(6px);\n}\n\n.team-card-body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 24px 24px 28px;\n}\n\n.team-card-name {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.team-card-role {\n  margin: 4px 0 18px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--secondary);\n}\n\n.team-card-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.team-card-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n  transition: color 0.15s ease;\n}\n\n.team-card-link svg {\n  flex: 0 0 auto;\n  padding: 7px;\n  width: 30px;\n  height: 30px;\n  border-radius: 9px;\n  color: var(--primary);\n  background: var(--primary-light);\n}\n\n.team-card-link span {\n  overflow-wrap: anywhere;\n}\n\n.team-card-link:hover {\n  color: var(--primary);\n}\n\n.team-card-bio p {\n  margin: 0 0 12px;\n  font-size: 14.5px;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n.team-card-bio p:last-child {\n  margin-bottom: 0;\n}\n\n.team-social {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px 24px;\n  margin-top: 40px;\n  padding: 24px 28px;\n  border-radius: 20px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n}\n\n.team-social-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.team-social-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.team-social-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px 8px 8px;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n  transition: border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;\n}\n\n.team-social-btn img {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n}\n\n.team-social-btn:hover {\n  border-color: var(--primary);\n  color: var(--primary);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 1000px) {\n  .team-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 900px) {\n  .team-section-lead {\n    margin-top: -70px;\n  }\n}\n\n@media (max-width: 640px) {\n  .team-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ===========================\n   ABOUT PAGE\n   =========================== */\n\n.about-section {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 72px 16px 0;\n}\n\n.about-eyebrow {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--secondary);\n}\n\n.about-eyebrow-light {\n  color: #7dd3fc;\n}\n\n.about-intro {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.about-lead {\n  margin: 0 0 18px;\n  font-size: clamp(24px, 2.6vw, 32px);\n  line-height: 1.3;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-main);\n}\n\n.about-body {\n  margin: 0;\n  font-size: 17px;\n  line-height: 1.75;\n  color: var(--text-muted);\n}\n\n.about-body + .about-body {\n  margin-top: 14px;\n}\n\n.about-intro-media img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: 24px;\n  box-shadow: 0 24px 50px rgba(15, 35, 95, 0.15);\n}\n\n.about-section-head {\n  margin-bottom: 28px;\n}\n\n.about-section-title {\n  margin: 0;\n  font-size: clamp(26px, 2.6vw, 34px);\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.about-principles {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.about-principle {\n  padding: 28px 26px;\n  border-radius: 20px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n  box-shadow: 0 4px 14px rgba(15, 35, 95, 0.04);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.about-principle:hover {\n  transform: translateY(-3px);\n  border-color: rgba(0, 82, 204, 0.2);\n  box-shadow: 0 18px 36px rgba(15, 35, 95, 0.1);\n}\n\n.about-principle-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  color: var(--primary);\n  background: var(--primary-light);\n}\n\n.about-principle h3 {\n  margin: 18px 0 8px;\n  font-size: 19px;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.about-principle p {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n.about-director {\n  display: grid;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n  border-radius: 28px;\n  overflow: hidden;\n  color: #e2e8f0;\n  background:\n    radial-gradient(500px 280px at 100% 0%, rgba(0, 163, 255, 0.3), transparent 70%),\n    #0f1b3d;\n  box-shadow: 0 24px 50px rgba(15, 27, 61, 0.22);\n}\n\n/* The photo fills its column at whatever height the text sets, instead of\n   its own (very tall) natural height setting the card's height. */\n.about-director-photo {\n  position: relative;\n  min-height: 360px;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.about-director-photo img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 20%;\n}\n\n.about-director-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 44px 48px;\n}\n\n.about-director-text h2 {\n  margin: 0 0 14px;\n  font-size: clamp(26px, 2.6vw, 34px);\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.about-director-text p {\n  margin: 0 0 26px;\n  font-size: 16.5px;\n  line-height: 1.75;\n  color: rgba(226, 232, 240, 0.82);\n}\n\n@media (max-width: 900px) {\n  .about-section {\n    padding-top: 52px;\n  }\n\n  .about-intro {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 28px;\n  }\n\n  .about-principles {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .about-director {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .about-director-photo {\n    min-height: 0;\n    aspect-ratio: 4 / 3;\n  }\n\n  .about-director-text {\n    padding: 28px 22px 30px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .team-card-photo img,\n  .about-principle {\n    transition: none;\n  }\n}\n\n\n/* ===========================\n   LEGAL PAGES (Privacy, Disclosure)\n   ===========================\n   Sticky numbered contents beside a white reading card. */\n\n.legal-layout {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 56px 16px 80px;\n  display: grid;\n  grid-template-columns: 260px minmax(0, 1fr);\n  gap: 40px;\n  align-items: start;\n}\n\n.legal-toc {\n  position: sticky;\n  top: calc(var(--nav-offset) + 16px);\n  max-height: calc(100vh - var(--nav-offset) - 32px);\n  overflow-y: auto;\n}\n\n.legal-toc-title {\n  margin: 0 0 12px;\n  padding-left: 12px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--secondary);\n}\n\n.legal-toc-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border-left: 2px solid #e2e8f0;\n}\n\n.legal-toc-link {\n  display: flex;\n  gap: 10px;\n  margin-left: -2px;\n  padding: 7px 12px;\n  border-left: 2px solid transparent;\n  font-size: 13.5px;\n  line-height: 1.45;\n  color: var(--text-muted);\n  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.legal-toc-link:hover {\n  color: var(--text-main);\n}\n\n.legal-toc-link.active {\n  border-left-color: var(--primary);\n  color: var(--primary);\n  font-weight: 600;\n  background: linear-gradient(90deg, rgba(0, 82, 204, 0.06), transparent);\n}\n\n.legal-toc-number {\n  flex: 0 0 18px;\n  font-variant-numeric: tabular-nums;\n  color: #94a3b8;\n}\n\n.legal-toc-link.active .legal-toc-number {\n  color: var(--primary);\n}\n\n.legal-toc-mobile {\n  display: none;\n}\n\n.legal-doc {\n  min-width: 0;\n  padding: 44px 52px;\n  border-radius: 24px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.06);\n  box-shadow: 0 10px 30px rgba(15, 35, 95, 0.06);\n  font-size: 15.5px;\n  line-height: 1.75;\n  color: #334155;\n}\n\n.legal-section {\n  /* Land anchored headings below the floating navbar, not under it. */\n  scroll-margin-top: calc(var(--nav-offset) + 16px);\n}\n\n.legal-section + .legal-section {\n  margin-top: 36px;\n  padding-top: 36px;\n  border-top: 1px solid #eef2f7;\n}\n\n.legal-section-title {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  margin: 0 0 14px;\n  font-size: 22px;\n  line-height: 1.3;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.legal-section-number {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  height: 34px;\n  padding: 0 8px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--primary);\n  background: var(--primary-light);\n  transform: translateY(-3px);\n}\n\n.legal-subhead {\n  margin: 24px 0 8px;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.legal-doc p {\n  margin: 0 0 14px;\n}\n\n.legal-doc ul {\n  margin: 0 0 16px;\n  padding-left: 22px;\n}\n\n.legal-doc li {\n  margin-bottom: 8px;\n  padding-left: 4px;\n}\n\n.legal-doc li::marker {\n  color: var(--secondary);\n}\n\n.legal-doc a {\n  color: var(--primary);\n  font-weight: 600;\n  text-decoration: underline;\n  text-decoration-color: rgba(0, 82, 204, 0.3);\n  text-underline-offset: 3px;\n}\n\n.legal-doc a:hover {\n  text-decoration-color: currentColor;\n}\n\n.legal-doc strong {\n  color: var(--text-main);\n}\n\n/* Disclosure: key details */\n.legal-details {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin: 0 0 40px;\n}\n\n.legal-detail {\n  padding: 16px 18px;\n  border-radius: 16px;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n}\n\n.legal-detail dt {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.legal-detail dd {\n  margin: 4px 0 0;\n  font-size: 15.5px;\n  font-weight: 700;\n  line-height: 1.45;\n  color: var(--text-main);\n}\n\n/* Disclosure: lender and insurer panels as tags, not 30-line lists */\n.legal-doc .legal-chips {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0;\n}\n\n.legal-doc .legal-chips li {\n  margin: 0;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #1e3a8a;\n  background: var(--primary-light);\n}\n\n.legal-callout {\n  margin: 0 0 14px;\n  padding: 18px 20px 4px;\n  border-radius: 16px;\n  border-left: 4px solid var(--primary);\n  background: #f8fafc;\n}\n\n.legal-doc .legal-contact-card {\n  padding: 18px 20px;\n  border-radius: 16px;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n}\n\n@media (max-width: 960px) {\n  .legal-layout {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 20px;\n    padding-top: 32px;\n  }\n\n  .legal-toc {\n    position: static;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .legal-toc-title,\n  .legal-toc-desktop {\n    display: none;\n  }\n\n  .legal-toc-mobile {\n    display: block;\n    border-radius: 16px;\n    background: #ffffff;\n    border: 1px solid rgba(15, 35, 95, 0.08);\n  }\n\n  .legal-toc-mobile summary {\n    padding: 14px 18px;\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--primary);\n    cursor: pointer;\n  }\n\n  .legal-toc-mobile .legal-toc-list {\n    margin: 0 18px 14px;\n  }\n\n  .legal-doc {\n    padding: 28px 20px;\n    font-size: 15px;\n  }\n\n  .legal-section-title {\n    font-size: 19px;\n    gap: 10px;\n  }\n\n  .legal-details {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ===========================\n   CAREERS PAGE\n   =========================== */\n\n.careers-section {\n  position: relative;\n  max-width: 860px;\n  margin: -100px auto 0;\n  padding: 0 16px 80px;\n}\n\n.careers-status {\n  padding: 36px 40px;\n  border-radius: 24px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.06);\n  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.12);\n}\n\n.careers-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #92400e;\n  background: #fef3c7;\n}\n\n.careers-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #f59e0b;\n}\n\n.careers-status h2 {\n  margin: 16px 0 10px;\n  font-size: clamp(24px, 2.6vw, 30px);\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.careers-status p {\n  margin: 0;\n  font-size: 16.5px;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n.careers-status strong {\n  color: var(--text-main);\n}\n\n.careers-block {\n  margin-top: 48px;\n}\n\n.careers-heading {\n  margin: 0 0 10px;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.careers-text {\n  margin: 0 0 12px;\n  font-size: 16px;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n.careers-text a {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.careers-text strong {\n  color: var(--text-main);\n}\n\n.careers-steps {\n  list-style: none;\n  margin: 20px 0;\n  padding: 0;\n  display: grid;\n  gap: 12px;\n}\n\n.careers-step {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 20px;\n  border-radius: 16px;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.07);\n  font-size: 15.5px;\n  line-height: 1.55;\n  color: var(--text-main);\n}\n\n.careers-step-number {\n  flex: 0 0 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  font-weight: 800;\n  color: var(--primary);\n  background: var(--primary-light);\n}\n\n.careers-email {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px 24px;\n  padding: 24px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, rgba(0, 82, 204, 0.06), rgba(0, 163, 255, 0.06));\n  border: 1px solid rgba(0, 82, 204, 0.12);\n}\n\n.careers-email > div {\n  flex: 1 1 320px;\n}\n\n.careers-email .careers-text {\n  margin: 0;\n}\n\n@media (max-width: 900px) {\n  .careers-section {\n    margin-top: -70px;\n    padding-bottom: 56px;\n  }\n\n  .careers-status {\n    padding: 26px 22px;\n  }\n\n  .careers-email {\n    padding: 20px;\n  }\n}\n\n/* ===========================\n   HOME HERO\n   =========================== */\n\n.hero {\n  position: relative;\n  margin-top: calc(-1 * var(--nav-offset));\n  padding: calc(var(--nav-offset) + 72px) 16px 96px;\n  color: #ffffff;\n  background:\n    linear-gradient(100deg, rgba(10, 20, 48, 0.94) 0%, rgba(10, 20, 48, 0.82) 45%, rgba(10, 20, 48, 0.45) 100%),\n    url(\"./assets/auckland-banner.png\") center / cover no-repeat;\n  overflow: hidden;\n}\n\n/* Soft blue glow so the left side isn't a flat block of navy */\n.hero::before {\n  content: \"\";\n  position: absolute;\n  inset: auto auto -30% -10%;\n  width: 60%;\n  height: 90%;\n  background: radial-gradient(closest-side, rgba(0, 82, 204, 0.45), transparent);\n  pointer-events: none;\n}\n\n.hero-inner {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.85fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n}\n\n.hero-badge-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.2);\n}\n\n.hero-title {\n  margin: 22px 0 18px;\n  font-size: clamp(38px, 5vw, 64px);\n  line-height: 1.05;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\n.hero-highlight {\n  background: linear-gradient(90deg, #60a5fa, #38bdf8);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.hero-punchline {\n  margin: 0;\n  max-width: 540px;\n  font-size: 18px;\n  line-height: 1.6;\n  color: rgba(226, 232, 240, 0.88);\n}\n\n.hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 32px;\n}\n\n.hero-usp-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 24px;\n  margin: 28px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.hero-usp-row li {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(226, 232, 240, 0.85);\n}\n\n.hero-usp-row svg {\n  flex: 0 0 auto;\n  padding: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  color: #0f1b3d;\n  background: #7dd3fc;\n}\n\n/* Glass \"how it works\" card */\n.hero-steps {\n  padding: 28px 26px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  -webkit-backdrop-filter: blur(14px);\n  backdrop-filter: blur(14px);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);\n}\n\n.hero-steps-title {\n  margin: 0 0 18px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.hero-steps ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.hero-step {\n  position: relative;\n  display: flex;\n  gap: 16px;\n  padding-bottom: 22px;\n}\n\n.hero-step:last-child {\n  padding-bottom: 0;\n}\n\n/* Line joining the step numbers */\n.hero-step:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  top: 38px;\n  bottom: 4px;\n  left: 17px;\n  width: 2px;\n  border-radius: 2px;\n  background: rgba(125, 211, 252, 0.25);\n}\n\n.hero-step-number {\n  flex: 0 0 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f1b3d;\n  background: linear-gradient(135deg, #ffffff, #bae6fd);\n}\n\n.hero-step-body {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding-top: 6px;\n}\n\n.hero-step-body strong {\n  font-size: 16px;\n  line-height: 1.35;\n  color: #ffffff;\n}\n\n.hero-step-body span {\n  font-size: 14px;\n  line-height: 1.5;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n@media (max-width: 960px) {\n  .hero {\n    padding: calc(var(--nav-offset) + 40px) 16px 64px;\n  }\n\n  .hero-inner {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 36px;\n  }\n\n  .hero-punchline {\n    font-size: 16.5px;\n  }\n}\n\n/* ===========================\n   CLIENT REVIEWS\n   =========================== */\n\n.reviews-section {\n  position: relative;\n  padding: 88px 16px;\n  color: #ffffff;\n  background:\n    radial-gradient(700px 360px at 0% 0%, rgba(0, 82, 204, 0.4), transparent 70%),\n    radial-gradient(600px 360px at 100% 100%, rgba(0, 163, 255, 0.22), transparent 70%),\n    #0b1531;\n  overflow: hidden;\n}\n\n.reviews-inner {\n  position: relative;\n  max-width: var(--container);\n  margin: 0 auto;\n}\n\n.reviews-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px 32px;\n  margin-bottom: 40px;\n}\n\n.reviews-kicker {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.reviews-title {\n  margin: 0;\n  max-width: 560px;\n  font-size: clamp(28px, 3.2vw, 42px);\n  line-height: 1.15;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n/* One row that drifts left forever, like the bank logos. Two copies of the\n   list sit in the track; it moves by exactly one copy (-50%) and restarts.\n   Spacing is margin on each card rather than flex gap, so both halves are\n   identical and the restart is seamless. */\n.reviews-marquee {\n  position: relative;\n  overflow: hidden;\n  padding: 6px 0 10px;\n  /* fade the cards in and out at the screen edges */\n  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);\n  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);\n}\n\n.reviews-track {\n  display: flex;\n  width: max-content;\n  animation: reviews-scroll 60s linear infinite;\n}\n\n/* Hold still while someone is reading a card */\n.reviews-marquee:hover .reviews-track {\n  animation-play-state: paused;\n}\n\n@keyframes reviews-scroll {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n.review-card {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 360px;\n  margin: 0 20px 0 0;\n  padding: 26px 24px 22px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n.review-card:hover {\n  transform: translateY(-3px);\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(125, 211, 252, 0.3);\n}\n\n.review-stars {\n  display: inline-flex;\n  gap: 2px;\n  color: #fbbf24;\n}\n\n.review-text {\n  position: relative;\n  margin: 14px 0 20px;\n  font-size: 16px;\n  line-height: 1.65;\n  color: rgba(241, 245, 249, 0.92);\n}\n\n.review-author {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.review-avatar {\n  flex: 0 0 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f1b3d;\n  background: linear-gradient(135deg, #bae6fd, #60a5fa);\n}\n\n.review-name {\n  display: block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.review-tag {\n  display: block;\n  font-size: 13px;\n  color: rgba(226, 232, 240, 0.6);\n}\n\n@media (max-width: 900px) {\n  .reviews-section {\n    padding: 60px 16px;\n  }\n\n  .reviews-head {\n    margin-bottom: 28px;\n  }\n\n  .review-card {\n    flex-basis: 300px;\n    margin-right: 14px;\n  }\n}\n\n/* ===========================\n   LOCATION (home)\n   =========================== */\n\n.location-section {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 80px 16px;\n}\n\n.location-head {\n  max-width: 640px;\n  margin: 0 auto 36px;\n  text-align: center;\n}\n\n.location-kicker {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--secondary);\n}\n\n.location-title {\n  margin: 0 0 12px;\n  font-size: clamp(28px, 3vw, 38px);\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.location-subtitle {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.65;\n  color: var(--text-muted);\n}\n\n/* One card: details on the left, the map filling the right */\n.location-panel {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  border-radius: 28px;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid rgba(15, 35, 95, 0.06);\n  box-shadow: 0 24px 60px rgba(15, 35, 95, 0.1);\n}\n\n.location-info {\n  display: flex;\n  flex-direction: column;\n  padding: 40px 40px 36px;\n}\n\n.location-address-block {\n  display: flex;\n  gap: 16px;\n}\n\n.location-pin {\n  flex: 0 0 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  color: #ffffff;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  box-shadow: 0 10px 22px rgba(0, 82, 204, 0.3);\n}\n\n.location-name {\n  margin: 0 0 4px;\n  font-size: 20px;\n  font-weight: 800;\n  color: var(--text-main);\n}\n\n.location-address {\n  margin: 0;\n  font-size: 15.5px;\n  line-height: 1.6;\n  color: #334155;\n}\n\n.location-note {\n  margin: 24px 0;\n  padding: 14px 16px;\n  border-radius: 14px;\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: #334155;\n  background: #f1f6ff;\n  border: 1px solid rgba(0, 82, 204, 0.1);\n}\n\n.location-points {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0 0 28px;\n  padding: 0;\n  list-style: none;\n}\n\n.location-points li {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  color: var(--text-main);\n}\n\n.location-point-icon {\n  flex: 0 0 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  color: var(--primary);\n  background: var(--primary-light);\n}\n\n.location-point-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.location-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 20px;\n  margin-top: auto;\n}\n\n.location-link {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.location-link:hover {\n  text-decoration: underline;\n}\n\n.location-map {\n  position: relative;\n  min-height: 460px;\n  background: #e8eef7;\n}\n\n.location-map iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n@media (max-width: 900px) {\n  .location-section {\n    padding: 56px 16px;\n  }\n\n  .location-panel {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .location-info {\n    padding: 28px 22px 26px;\n  }\n\n  .location-map {\n    min-height: 320px;\n  }\n}\n\n/* No auto-motion for people who ask for less: the strip becomes a row they\n   can swipe or scroll themselves. */\n@media (prefers-reduced-motion: reduce) {\n  .reviews-track {\n    animation: none;\n  }\n\n  .reviews-marquee {\n    overflow-x: auto;\n  }\n\n  .review-card {\n    transition: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
